(function () {
    'use strict';

    angular
        .module('appback')
        .controller('KanbanController', KanbanController)
        .directive('kanbanScrollEnd', kanbanScrollEnd);

    // Ejecuta la expresión indicada cuando se llega (casi) al final del
    // scroll del elemento. Se usa para ir mostrando más filas en listas
    // largas, p. ej. kanban-scroll-end="vm.showMorePetitionProducts(item)".
    kanbanScrollEnd.$inject = [];

    function kanbanScrollEnd() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                var el = element[0];
                var threshold = 40;

                function onScroll() {
                    if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
                        scope.$applyAsync(attrs.kanbanScrollEnd);
                    }
                }

                el.addEventListener('scroll', onScroll);

                scope.$on('$destroy', function () {
                    el.removeEventListener('scroll', onScroll);
                });
            }
        };
    }

    KanbanController.$inject = ["KanbanService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "$interval", "$scope", "$q"];

    function KanbanController(KanbanService, $http, $timeout, $uibModal, $log, $document, $sce, $interval, $scope, $q) {

        var vm = this;

        // Textos traducibles: la clave es el texto en inglés y la traducción
        // llega de showcards.twig (window.kanbanI18n, generado con t.getTraduction).
        // {nombre} se sustituye por params.nombre.
        function tr(text, params) {
            var dict = window.kanbanI18n || {};
            var result = dict[text] || text;
            angular.forEach(params || {}, function (value, key) {
                result = result.split('{' + key + '}').join(value);
            });
            return result;
        }

        vm.tr = tr;

        vm.cards = [];
        vm.users = [];
        vm.selectedUsers = [];
        vm.currentUser = null;

        var draggedCard = null;

        vm.isEditingViewCard = false;
        vm.isAddListModalOpen = false;

        vm.newList = {
            name: '',
            requireResponsible: true,
            responsable_id: null,
            max_time_hours: null,
            max_time_minutes: null,
            expire_action: 'decline',
            changeAssignee: false,
            assign_to: null
        };

        vm.newListResponsibleSearchTerm = '';
        vm.newListAssigneeSearchTerm = '';

        vm.isEditListModalOpen = false;

        vm.editList = {
            id: null,
            name: '',
            requireResponsible: true,
            responsable_id: null,
            max_time_hours: null,
            max_time_minutes: null,
            expire_action: 'decline',
            changeAssignee: false,
            assign_to: null
        };

        vm.editListResponsibleSearchTerm = '';
        vm.editListAssigneeSearchTerm = '';

        // Popup de error (modals/_error.twig). "detail" es el mensaje que
        // devuelva el servidor, si lo hay.
        vm.errorModal = {
            open: false,
            message: '',
            detail: ''
        };

        vm.showError = function (message, error) {

            var detail = '';

            if (error) {
                if (error.data && error.data.message) {
                    detail = error.data.message;
                } else if (error.message) {
                    detail = error.message;
                } else if (angular.isString(error)) {
                    detail = error;
                }
            }

            vm.errorModal = {
                open: true,
                message: message,
                detail: detail !== message ? detail : ''
            };
        };

        vm.closeErrorModal = function () {
            vm.errorModal.open = false;
        };

        // Popup de confirmación (modals/_confirm.twig), en lugar de confirm().
        // onConfirm se ejecuta solo si el usuario pulsa el botón de confirmar.
        // variant: 'danger' (rojo) o 'primary' (turquesa).
        vm.confirmModal = {
            open: false,
            title: '',
            message: '',
            confirmLabel: '',
            icon: '',
            variant: 'primary',
            onConfirm: null
        };

        vm.askConfirm = function (options) {
            vm.confirmModal = {
                open: true,
                title: options.title,
                message: options.message,
                confirmLabel: options.confirmLabel || tr('Accept'),
                icon: options.icon || 'help',
                variant: options.variant || 'primary',
                onConfirm: options.onConfirm
            };
        };

        vm.closeConfirmModal = function () {
            vm.confirmModal.open = false;
            vm.confirmModal.onConfirm = null;
        };

        vm.acceptConfirmModal = function () {

            var onConfirm = vm.confirmModal.onConfirm;

            vm.closeConfirmModal();

            if (onConfirm) {
                onConfirm();
            }
        };

        // Errores de validación por campo ("formulario.campo" => mensaje). Los
        // modales marcan en rojo los campos que aparecen aquí.
        vm.fieldErrors = {};

        vm.setFieldErrors = function (errors) {
            vm.fieldErrors = errors;

            return Object.keys(errors).length === 0;
        };

        vm.clearFieldError = function (key) {
            delete vm.fieldErrors[key];
        };

        vm.resetFieldErrors = function () {
            vm.fieldErrors = {};
        };

        vm.getCurrentUser = function () {
            return KanbanService.GetCurrentUser().then(function (response) {
                if (response && response.success && response.user) {
                    vm.currentUser = response.user;
                } else {
                    vm.showError(tr('Could not get the current user.'), response);
                }
                return response;
            }).catch(function (error) {
                vm.showError(tr('Error getting the current user.'), error);
                return $q.reject(error);
            });
        };

        vm.getCurrentUser();

        // Selector de tablero en la cabecera: el estado activo se guarda en la
        // URL (?board=id), así que cambiar de tablero recarga la página con las
        // tarjetas ya filtradas en el servidor (actionShowcards).
        vm.boards = [];
        vm.selectedBoard = null;

        vm.getBoards = function () {
            return KanbanService.GetBoards().then(function (response) {
                if (response && response.success) {
                    vm.boards = response.boards || [];

                    var boardIdFromUrl = new URLSearchParams(window.location.search).get('board');

                    var matched = boardIdFromUrl ? vm.boards.find(function (board) {
                        return String(board.id) === String(boardIdFromUrl);
                    }) : null;

                    vm.selectedBoard = matched || vm.boards[0] || null;
                } else {
                    vm.showError(tr('Could not get the boards.'), response);
                }
                return response;
            }).catch(function (error) {
                vm.showError(tr('Error getting the boards.'), error);
                return $q.reject(error);
            });
        };

        vm.getBoards();

        vm.selectBoard = function (board) {

            if (!board || (vm.selectedBoard && vm.selectedBoard.id === board.id)) {
                return;
            }

            window.location.href = '/backend/kanban/showcards?board=' + encodeURIComponent(board.id);
        };

        vm.toggleUser = function (user) {

            var index = vm.selectedUsers.indexOf(user.id);

            if (index === -1) {
                vm.selectedUsers.push(user.id);
            } else {
                vm.selectedUsers.splice(index, 1);
            }
        };

        vm.getUsers = function () {
            return KanbanService.GetUsers().then(function (data) {
                vm.allUsers = data.users || data;

                return vm.allUsers;
            }).catch(function (error) {
                vm.showError(tr('Error getting the users.'), error);
                return $q.reject(error);
            });
        };

        vm.getCards = function () {

            return KanbanService.Getcards().then(function (data) {

                vm.cards = data;
                return data;

            }, function (error) {

                console.log("error:", error);

            });
        };

        vm.getCard = function (id) {
            return KanbanService.Getcard(id).then(function (data) {
                return data;
            }, function (error) {
                console.log("error:", error);
                return $q.reject(error);
            });
        };

        vm.updateStateCard = function (cardId, stateId) {

            return KanbanService.UpdateStateCard(cardId, stateId).then(function (data) {

                if (!data.success) {
                    return $q.reject(data);
                }

                return data;

            }, function (error) {

                return $q.reject(error);
            });
        };

        vm.initDragAndDrop = function () {

            var cards = document.querySelectorAll('.kanban-card');
            var states = document.querySelectorAll('.kanban-column');

            cards.forEach(function (card) {
                vm.initCardDragAndDrop(card);
            });

            states.forEach(function (state) {

                vm.initStateDragAndDrop(state);

            });
        };

        vm.initStateDragAndDrop = function (state) {

            vm.enableColumnTitleInlineEdit(state);

            state.addEventListener('dragover', function (event) {

                event.preventDefault();
                event.dataTransfer.dropEffect = 'move';
                state.classList.add('ring-2');
            });

            state.addEventListener('dragleave', function (event) {

                if (!state.contains(event.relatedTarget)) {
                    state.classList.remove('ring-2');
                }
            });

            state.addEventListener('drop', function (event) {

                event.preventDefault();
                state.classList.remove('ring-2');

                if (!draggedCard) {
                    return;
                }

                var cardElement = draggedCard;
                var cardId = cardElement.dataset.cardId;
                var newStateId = state.dataset.stateId;
                var oldState = cardElement.closest('.kanban-column');
                var oldStateId = oldState ? oldState.dataset.stateId : null;
                var oldContainer = cardElement.parentElement;


                if (String(oldStateId) === String(newStateId)) {
                    draggedCard = null;
                    return;
                }

                cardElement.style.pointerEvents = 'none';

                $scope.$applyAsync(function () {
                    vm.updateStateCard(cardId, newStateId).then(function (data) {

                        if (data && data.card) {
                            vm.updateCardInBoard(data.card);
                        }
                    }).catch(function (error) {

                        vm.showError(tr('Could not move the OT.'), error);

                        if (oldContainer && cardElement) {
                            oldContainer.appendChild(cardElement);
                        }

                    }).finally(function () {

                        cardElement.style.pointerEvents = '';

                        draggedCard = null;
                    });
                });
            });
        };

        vm.enableColumnTitleInlineEdit = function (state) {

            var titleEl = state.querySelector('.kanban-column-title');

            if (!titleEl) {
                return;
            }

            titleEl.classList.add('kanban-column-title-editable');

            titleEl.addEventListener('click', function (event) {
                event.stopPropagation();
                vm.startEditingColumnTitle(state, titleEl);
            });
        };

        vm.startEditingColumnTitle = function (state, titleEl) {

            if (titleEl.querySelector('input')) {
                return;
            }

            var stateId = state.dataset.stateId;
            var originalName = titleEl.textContent.trim();

            var input = document.createElement('input');
            input.type = 'text';
            input.className = 'kanban-column-title-input form-control form-control-sm fw-bold';
            input.value = originalName;

            titleEl.textContent = '';
            titleEl.appendChild(input);

            input.focus();
            input.select();

            var finished = false;

            function exitEditMode(displayName) {
                titleEl.textContent = displayName;
            }

            function saveName() {

                if (finished) {
                    return;
                }

                finished = true;

                var newName = input.value.trim();

                if (!newName || newName === originalName) {
                    exitEditMode(originalName);
                    return;
                }

                KanbanService.UpdateStateName(stateId, newName).then(function (data) {

                    if (!data || !data.success) {
                        return $q.reject(data);
                    }

                    exitEditMode(newName);

                    state.dataset.stateName = newName;
                }).catch(function (error) {

                    vm.showError(tr('Could not update the list name.'), error);

                    exitEditMode(originalName);
                });
            }

            input.addEventListener('blur', saveName);

            input.addEventListener('click', function (event) {
                event.stopPropagation();
            });

            input.addEventListener('keydown', function (event) {

                event.stopPropagation();

                if (event.key === 'Enter') {
                    event.preventDefault();
                    input.blur();
                }

                if (event.key === 'Escape') {
                    finished = true;
                    exitEditMode(originalName);
                }
            });
        };

        vm.updateStateCounters = function () {

            var states = document.querySelectorAll('.kanban-column');

            states.forEach(function (state) {

                var container = state.querySelector('.kanban-cards');

                var counter = state.querySelector('.kanban-card-counter');

                if (container && counter) {

                    var count = container.querySelectorAll('.kanban-card').length;
                    counter.textContent = '(' + count + ')';

                    var deleteStateBtn = state.querySelector('.kanban-delete-state-btn');

                    if (deleteStateBtn) {

                        var hasCards = count >= 1;

                        deleteStateBtn.disabled = hasCards;

                        if (hasCards) {
                            deleteStateBtn.setAttribute('title', tr('A list with OTs cannot be deleted'));
                        } else {
                            deleteStateBtn.removeAttribute('title');
                        }
                    }
                }
            });
        };


        vm.updateEmptyMessage = function (state) {

            var container = state.querySelector('.kanban-cards');

            if (!container) {
                return;
            }

            var cards = container.querySelectorAll('.kanban-card');

            var emptyMessage = container.querySelector('.kanban-empty-message');


            // No hay tarjetas
            if (cards.length === 0) {

                if (!emptyMessage) {

                    emptyMessage = document.createElement('div');

                    emptyMessage.className = 'kanban-empty-message text-center text-muted small py-4';

                    emptyMessage.textContent = tr('No OTs');
                    container.appendChild(emptyMessage);
                }
            } else {
                if (emptyMessage) {
                    emptyMessage.remove();
                }
            }
        };

        $timeout(function () {
            vm.initDragAndDrop();

        }, 0);

        vm.openAddListModal = function () {

            vm.newList = {
                name: '',
                requireResponsible: true,
                responsable_id: null,
                max_time_hours: null,
                max_time_minutes: null,
                expire_action: 'decline',
                changeAssignee: false,
                assign_to: null
            };

            vm.newListResponsibleSearchTerm = '';
            vm.newListAssigneeSearchTerm = '';

            vm.resetFieldErrors();

            vm.isAddListModalOpen = true;

            vm.getUsers();
        };

        vm.closeAddListModal = function () {
            vm.isAddListModalOpen = false;

            vm.resetFieldErrors();

            vm.newList = {
                name: '',
                requireResponsible: true,
                responsable_id: null,
                max_time_hours: null,
                max_time_minutes: null,
                expire_action: 'decline',
                changeAssignee: false,
                assign_to: null
            };

            vm.newListResponsibleSearchTerm = '';
            vm.newListAssigneeSearchTerm = '';
        };

        vm.selectNewListResponsible = function (user, event) {
            vm.newList.responsable_id = user.id;

            vm.clearFieldError('newList.responsable_id');

            vm.closeDropdown(event);
        };

        vm.selectNewListAssignee = function (user, event) {
            vm.newList.assign_to = user.id;

            vm.clearFieldError('newList.assign_to');

            vm.closeDropdown(event);
        };

        vm.isNewListAssigneeSelected = function (user) {
            return vm.newList.assign_to === user.id;
        };

        vm.getNewListAssigneeName = function () {

            if (!vm.newList.assign_to || !vm.allUsers) {
                return '';
            }

            var user = vm.allUsers.find(function (u) {
                return String(u.id) === String(vm.newList.assign_to);
            });

            return vm.getUserFullName(user);
        };

        vm.closeDropdown = function (event) {

            if (!event) {
                return;
            }

            var dropdownEl = event.currentTarget ? event.currentTarget.closest('.dropdown') : null;

            var toggleEl = dropdownEl ? dropdownEl.querySelector('[data-bs-toggle="dropdown"]') : null;

            if (!toggleEl || !window.bootstrap || !window.bootstrap.Dropdown) {
                return;
            }

            var instance = window.bootstrap.Dropdown.getInstance(toggleEl) || new window.bootstrap.Dropdown(toggleEl);

            instance.hide();
        };

        // Al abrir un desplegable se cierran los demás que sigan abiertos (con
        // data-bs-auto-close="outside" Bootstrap no los cierra por sí solo).
        function closeOtherDropdowns(event) {

            if (!window.bootstrap || !window.bootstrap.Dropdown) {
                return;
            }

            var openingToggle = event.target;

            document.querySelectorAll('[data-bs-toggle="dropdown"].show').forEach(function (toggleEl) {

                // No se cierra el que se abre ni el desplegable que lo contiene.
                if (toggleEl === openingToggle || (toggleEl.parentElement && toggleEl.parentElement.contains(openingToggle))) {
                    return;
                }

                var instance = window.bootstrap.Dropdown.getInstance(toggleEl);

                if (instance) {
                    instance.hide();
                }
            });
        }

        document.addEventListener('show.bs.dropdown', closeOtherDropdowns);

        $scope.$on('$destroy', function () {
            document.removeEventListener('show.bs.dropdown', closeOtherDropdowns);
        });

        vm.isNewListResponsibleSelected = function (user) {
            return vm.newList.responsable_id === user.id;
        };

        vm.getNewListResponsibleName = function () {

            if (!vm.newList.responsable_id || !vm.allUsers) {
                return '';
            }

            var user = vm.allUsers.find(function (u) {
                return String(u.id) === String(vm.newList.responsable_id);
            });

            return vm.getUserFullName(user);
        };

        vm.getUserFullName = function (user) {

            if (!user) {
                return '';
            }

            return [user.name, user.surname].filter(Boolean).join(' ');
        };

        // Plazo de aprobación de un estado: en los modales se indica en horas y
        // minutos y se guarda en max_time como total de minutos.
        function listMaxTimeMinutes(list) {
            var hours = Math.max(0, Math.floor(Number(list.max_time_hours) || 0));
            var minutes = Math.max(0, Math.floor(Number(list.max_time_minutes) || 0));

            return hours * 60 + minutes;
        }

        vm.createList = function () {
            var listName = (vm.newList.name || '').trim();
            var requireResponsible = !!vm.newList.requireResponsible;
            var changeAssignee = !!vm.newList.changeAssignee;

            var errors = {};

            if (!listName) {
                errors['newList.name'] = tr('You must enter a name for the list.');
            }

            if (requireResponsible && !vm.newList.responsable_id) {
                errors['newList.responsable_id'] = tr('You must select a person in charge.');
            }

            if (requireResponsible && listMaxTimeMinutes(vm.newList) <= 0) {
                errors['newList.max_time'] = tr('You must enter a maximum time in hours and minutes.');
            }

            if (changeAssignee && !vm.newList.assign_to) {
                errors['newList.assign_to'] = tr('You must select the person to be assigned.');
            }

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            var payload = {
                name: listName,
                responsable_id: requireResponsible ? vm.newList.responsable_id : null,
                max_time: requireResponsible ? listMaxTimeMinutes(vm.newList) : null,
                expire_action: requireResponsible ? vm.newList.expire_action : null,
                assign_to: changeAssignee ? vm.newList.assign_to : null,
                board: vm.selectedBoard ? vm.selectedBoard.id : null
            };

            KanbanService.CreateState(payload)
                .then(function (data) {
                    if (!data || !data.success) {
                        return $q.reject(data || { message: tr('Could not create the list.') });
                    }
                    $scope.$applyAsync(function () {
                        vm.addStateColumn(data.state);
                        vm.closeAddListModal();
                    });
                }).catch(function (error) {
                    vm.showError(tr('Could not create the list.'), error);
                });
        };

        vm.addStateColumn = function (stateData) {
            var board = document.querySelector('.kanban-scroll');

            if (!board) {
                throw new Error('Kanban container not found.');
            }

            var column = document.createElement('div');
            column.className = 'kanban-column bg-white d-flex flex-column rounded-4 position-relative';
            column.dataset.stateId = stateData.id;
            column.dataset.stateName = stateData.name;
            column.innerHTML = `
                <div class="kanban-column-header p-2 d-flex justify-content-between align-items-start sticky-top rounded-top-4">
                    <div class="px-2">
                        <h3 class="h6 fw-bold m-0">
                            <span class="kanban-column-title">${stateData.name}</span>
                            <span class="kanban-card-counter badge rounded-pill text-bg-light text-muted ms-1">0</span>
                        </h3>
                        ${stateData.responsable ? `<div class="small text-muted d-flex align-items-center gap-1 mt-1 kanban-column-responsible">
                            <span class="material-symbols-outlined" style="font-size:14px">person</span>
                            ${vm.getUserFullName(stateData.responsable)}
                        </div>` : ''}
                    </div>
                    <div class="dropdown">
                        <button type="button" class="btn btn-sm btn-light text-muted" data-bs-toggle="dropdown" aria-expanded="false">
                            <span class="material-symbols-outlined" style="font-size:20px">more_vert</span>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end kanban-state-menu">
                            <li><button type="button" class="dropdown-item kanban-edit-state-btn">${tr('Edit')}</button></li>
                            <li><button type="button" class="dropdown-item text-danger kanban-delete-state-btn">${tr('Delete')}</button></li>
                        </ul>
                    </div>
                </div>
                <div class="kanban-cards flex-fill overflow-auto kanban-scroll p-2 d-flex flex-column gap-2">
                    <div class="kanban-empty-message text-center text-muted small py-4">${tr('No OTs')}</div>
                </div>
                <div class="p-2 bg-white rounded-bottom-4 border-top">
                    <button class="btn rounded-pill w-100 text-start d-flex align-items-center gap-2 kanban-add-card-button">
                        <span class="material-symbols-outlined" style="font-size:18px">add</span>
                        ${tr('New OT')}
                    </button>
                </div>`;

            var addListButton = board.querySelector('.kanban-add-list-button');


            if (addListButton) {

                board.insertBefore(column, addListButton);

            } else {

                board.appendChild(column);
            }

            vm.initStateDragAndDrop(column);

            var deleteStateBtn = column.querySelector('.kanban-delete-state-btn');

            if (deleteStateBtn) {
                deleteStateBtn.addEventListener('click', function (event) {
                    event.stopPropagation();
                    $scope.$applyAsync(function () {
                        vm.deleteState(stateData.id);
                    });
                });
            }

            var editStateBtn = column.querySelector('.kanban-edit-state-btn');

            if (editStateBtn) {
                editStateBtn.addEventListener('click', function (event) {
                    event.stopPropagation();
                    $scope.$applyAsync(function () {
                        vm.openEditListModal(stateData.id);
                    });
                });
            }

            var addCardBtn = column.querySelector('.kanban-add-card-button');

            if (addCardBtn) {
                addCardBtn.addEventListener('click', function () {
                    $scope.$applyAsync(function () {
                        vm.openNewCardModal(stateData.id);
                    });
                });
            }

        };

        vm.deleteState = function (stateId) {

            var column = document.querySelector('.kanban-column[data-state-id="' + stateId + '"]');
            var stateName = column ? column.dataset.stateName : '';

            vm.askConfirm({
                title: tr('Delete list'),
                message: tr('Are you sure you want to delete the list{name}?', { name: stateName ? ' "' + stateName + '"' : '' }),
                confirmLabel: tr('Delete list'),
                icon: 'delete',
                variant: 'danger',
                onConfirm: function () {
                    return vm.executeDeleteState(stateId);
                }
            });
        };

        vm.executeDeleteState = function (stateId) {

            return KanbanService.DeleteState(stateId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                var column = document.querySelector('.kanban-column[data-state-id="' + stateId + '"]');

                if (column) {
                    column.remove();
                }

                return data;
            }).catch(function (error) {

                vm.showError(tr('Could not delete the list.'), error);
            });
        };

        vm.handleNewListKey = function (event) {

            if (event.key === 'Enter') {
                vm.createList();
            }
            if (event.key === 'Escape') {
                vm.closeAddListModal();
            }
        };

        vm.openEditListModal = function (stateId) {

            return KanbanService.GetState(stateId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                var state = data.state;

                // max_time viene en minutos: se reparte en horas y minutos.
                var maxTime = Math.max(0, parseInt(state.max_time, 10) || 0);

                vm.editList = {
                    id: state.id,
                    name: state.name,
                    requireResponsible: !!(state.responsable_id && maxTime),
                    responsable_id: state.responsable_id ? state.responsable_id.id : null,
                    max_time_hours: maxTime ? Math.floor(maxTime / 60) : null,
                    max_time_minutes: maxTime ? maxTime % 60 : null,
                    // Vacío = rechazar (comportamiento anterior al campo).
                    expire_action: ['accept', 'decline', 'none'].indexOf(state.expire_action) !== -1 ? state.expire_action : 'decline',
                    changeAssignee: !!state.assign_to,
                    assign_to: state.assign_to ? state.assign_to.id : null
                };

                vm.editListResponsibleSearchTerm = '';
                vm.editListAssigneeSearchTerm = '';

                vm.resetFieldErrors();

                vm.isEditListModalOpen = true;

                return vm.getUsers();

            }).catch(function (error) {

                vm.showError(tr('Could not get the list.'), error);
            });
        };

        vm.closeEditListModal = function () {

            vm.isEditListModalOpen = false;

            vm.resetFieldErrors();

            vm.editList = {
                id: null,
                name: '',
                requireResponsible: true,
                responsable_id: null,
                max_time_hours: null,
                max_time_minutes: null,
                expire_action: 'decline',
                changeAssignee: false,
                assign_to: null
            };

            vm.editListResponsibleSearchTerm = '';
            vm.editListAssigneeSearchTerm = '';
        };

        vm.selectEditListResponsible = function (user, event) {
            vm.editList.responsable_id = user.id;

            vm.clearFieldError('editList.responsable_id');

            vm.closeDropdown(event);
        };

        vm.isEditListResponsibleSelected = function (user) {
            return vm.editList.responsable_id === user.id;
        };

        vm.getEditListResponsibleName = function () {

            if (!vm.editList.responsable_id || !vm.allUsers) {
                return '';
            }

            var user = vm.allUsers.find(function (u) {
                return String(u.id) === String(vm.editList.responsable_id);
            });

            return vm.getUserFullName(user);
        };

        vm.selectEditListAssignee = function (user, event) {
            vm.editList.assign_to = user.id;

            vm.clearFieldError('editList.assign_to');

            vm.closeDropdown(event);
        };

        vm.isEditListAssigneeSelected = function (user) {
            return vm.editList.assign_to === user.id;
        };

        vm.getEditListAssigneeName = function () {

            if (!vm.editList.assign_to || !vm.allUsers) {
                return '';
            }

            var user = vm.allUsers.find(function (u) {
                return String(u.id) === String(vm.editList.assign_to);
            });

            return vm.getUserFullName(user);
        };

        vm.updateList = function () {

            var listName = (vm.editList.name || '').trim();
            var requireResponsible = !!vm.editList.requireResponsible;
            var changeAssignee = !!vm.editList.changeAssignee;

            var errors = {};

            if (!listName) {
                errors['editList.name'] = tr('You must enter a name for the list.');
            }

            if (requireResponsible && !vm.editList.responsable_id) {
                errors['editList.responsable_id'] = tr('You must select a person in charge.');
            }

            if (requireResponsible && listMaxTimeMinutes(vm.editList) <= 0) {
                errors['editList.max_time'] = tr('You must enter a maximum time in hours and minutes.');
            }

            if (changeAssignee && !vm.editList.assign_to) {
                errors['editList.assign_to'] = tr('You must select the person to be assigned.');
            }

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            var payload = {
                id: vm.editList.id,
                name: listName,
                responsable_id: requireResponsible ? vm.editList.responsable_id : null,
                max_time: requireResponsible ? listMaxTimeMinutes(vm.editList) : null,
                expire_action: requireResponsible ? vm.editList.expire_action : null,
                assign_to: changeAssignee ? vm.editList.assign_to : null
            };

            KanbanService.UpdateState(payload)
                .then(function (data) {
                    if (!data || !data.success) {
                        return $q.reject(data || { message: tr('Could not update the list.') });
                    }
                    $scope.$applyAsync(function () {
                        vm.updateStateColumn(data.state);

                        if (angular.isArray(data.updatedCards)) {
                            data.updatedCards.forEach(function (card) {
                                vm.updateCardInBoard(card);
                            });
                        }

                        vm.closeEditListModal();
                    });
                }).catch(function (error) {
                    vm.showError(tr('Could not update the list.'), error);
                });
        };

        vm.handleEditListKey = function (event) {

            if (event.key === 'Enter') {
                vm.updateList();
            }
            if (event.key === 'Escape') {
                vm.closeEditListModal();
            }
        };

        vm.updateStateColumn = function (stateData) {

            var column = document.querySelector('.kanban-column[data-state-id="' + stateData.id + '"]');

            if (!column) {
                return;
            }

            column.dataset.stateName = stateData.name;

            var titleEl = column.querySelector('.kanban-column-title');

            if (titleEl) {
                titleEl.textContent = stateData.name;
            }

            var responsibleEl = column.querySelector('.kanban-column-responsible');

            if (stateData.responsable) {

                var fullName = vm.getUserFullName(stateData.responsable);

                if (responsibleEl) {

                    responsibleEl.innerHTML = '<span class="material-symbols-outlined" style="font-size:14px">person</span> ' + fullName;

                } else {

                    var titleWrapper = column.querySelector('.kanban-column-header > div');

                    if (titleWrapper) {
                        var responsibleDiv = document.createElement('div');
                        responsibleDiv.className = 'small text-muted d-flex align-items-center gap-1 mt-1 kanban-column-responsible';
                        responsibleDiv.innerHTML = '<span class="material-symbols-outlined" style="font-size:14px">person</span> ' + fullName;
                        titleWrapper.appendChild(responsibleDiv);
                    }
                }
            } else if (responsibleEl) {
                responsibleEl.remove();
            }
        };

        vm.isNewCardModalOpen = false;

        vm.newCard = {
            title: '',
            short_description: '',
            description: '',
            state: null,
            img: null,
            time_estimate_hours: null,
            time_estimate_minutes: null,
            priority: false,
            is_recurring: false,
            recurring_days: null,
            assigned_to: null,
            planification_date: null,
            maintenance_application: null,
            corrective_ot: null,
            parent_card: null
        };

        // Tipos de falla (corrective_ot) para el desplegable del modal de
        // nueva tarjeta y de la edición de la información general.
        vm.correctiveOts = [];

        vm.getCorrectiveOts = function () {
            return KanbanService.GetCorrectiveOts().then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.correctiveOts = withStringIds(data.correctiveOts);

                return vm.correctiveOts;

            }).catch(function (error) {

                vm.showError(tr('Could not get the failure types.'), error);
            });
        };

        // Tipos de solicitud de mantenimiento (maintenance_application) para
        // el desplegable del modal de nueva tarjeta.
        vm.maintenanceApplications = [];

        vm.getMaintenanceApplications = function () {
            return KanbanService.GetMaintenanceApplications().then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.maintenanceApplications = withStringIds(data.applications);

                return vm.maintenanceApplications;

            }).catch(function (error) {

                vm.showError(tr('Could not get the maintenance types.'), error);
            });
        };

        // Tipo de solicitud con ese id (para el nombre y el color del
        // desplegable), o null.
        vm.getMaintenanceApplication = function (applicationId) {

            if (!applicationId) {
                return null;
            }

            return vm.maintenanceApplications.find(function (item) {
                return String(item.id) === String(applicationId);
            }) || null;
        };

        // Al marcar una tarjeta como recurrente se le pone el tipo de
        // mantenimiento preventivo (el maestro cuyo nombre empieza por
        // "Preventiv", sin distinguir mayúsculas ni acentos).
        vm.onRecurringChange = function (card) {

            if (!card || !card.is_recurring) {
                return;
            }

            var preventive = vm.maintenanceApplications.find(function (item) {
                var name = String(item.name || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
                return name.indexOf('preventiv') === 0;
            });

            if (preventive) {
                card.maintenance_application = preventive.id;
            }
        };


        vm.openNewCardModal = function (stateId) {

            vm.newCard = {
                title: '',
                short_description: '',
                description: '',
                state: stateId,
                img: null,
                time_estimate_hours: null,
                time_estimate_minutes: null,
                priority: false,
                is_recurring: false,
                recurring_days: null,
                assigned_to: null,
                planification_date: null,
                maintenance_application: null,
                corrective_ot: null,
                parent_card: null
            };

            vm.newCardParentPicker = createCardPicker();

            vm.resetFieldErrors();

            vm.isNewCardModalOpen = true;

            vm.getMaintenanceApplications();
            vm.getCorrectiveOts();
        };


        vm.closeNewCardModal = function () {

            vm.isNewCardModalOpen = false;

            vm.resetFieldErrors();

            vm.newCard = {
                title: '',
                short_description: '',
                description: '',
                state: null,
                img: null,
                time_estimate_hours: null,
                time_estimate_minutes: null,
                priority: false,
                is_recurring: false,
                recurring_days: null,
                assigned_to: null,
                planification_date: null,
                maintenance_application: null,
                corrective_ot: null,
                parent_card: null
            };
        };

        // --- Tarjeta padre / tarjetas derivadas --------------------------

        // Estado de un desplegable de búsqueda de tarjetas.
        function createCardPicker() {
            return {
                search: '',
                results: [],
                loading: false,
                loaded: false,
                requestId: 0
            };
        }

        vm.newCardParentPicker = createCardPicker();
        vm.relatedCardsPicker = createCardPicker();
        vm.savingRelatedCards = false;

        // Busca tarjetas por título o id. Se descartan las respuestas de
        // búsquedas ya superadas.
        function searchCardsForPicker(picker, excludeIds) {

            var requestId = ++picker.requestId;

            picker.loading = true;

            return KanbanService.SearchCards(picker.search, excludeIds).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                if (requestId !== picker.requestId) {
                    return;
                }

                picker.results = data.cards || [];
                picker.loaded = true;

            }).catch(function (error) {

                if (requestId === picker.requestId) {
                    vm.showError(tr('Could not search the OTs.'), error);
                }

            }).finally(function () {

                if (requestId === picker.requestId) {
                    picker.loading = false;
                }
            });
        }

        // Modal de nueva tarjeta: tarjeta padre de la nueva tarjeta (una sola).
        // Viene ya elegida si se crea desde "Tarjetas derivadas".
        vm.openNewCardParentDropdown = function () {
            if (!vm.newCardParentPicker.loaded && !vm.newCardParentPicker.loading) {
                searchCardsForPicker(vm.newCardParentPicker, []);
            }
        };

        vm.searchNewCardParent = function () {
            return searchCardsForPicker(vm.newCardParentPicker, []);
        };

        vm.isNewCardParent = function (card) {
            return !!(vm.newCard.parent_card && card && String(vm.newCard.parent_card.id) === String(card.id));
        };

        // Pulsar la ya elegida la quita.
        vm.selectNewCardParent = function (card) {

            if (vm.isNewCardParent(card)) {
                vm.clearNewCardParent();
                return;
            }

            vm.newCard.parent_card = { id: String(card.id), title: card.title };
        };

        vm.clearNewCardParent = function () {
            vm.newCard.parent_card = null;
        };

        // Pestaña "Tarjetas derivadas": se ocultan la propia tarjeta, su
        // tarjeta padre y las que ya son derivadas.
        function currentRelatedIds() {
            return ((vm.viewCard && vm.viewCard.related_cards) || []).map(function (related) {
                return String(related.id);
            });
        }

        function relatedPickerExcludeIds() {
            var excludeIds = [String(vm.viewCard.id)];

            if (vm.viewCard.parent_card) {
                excludeIds.push(String(vm.viewCard.parent_card.id));
            }

            return excludeIds.concat(currentRelatedIds());
        }

        // Pestaña "Tarjeta padre": se enlaza una sola tarjeta. Se ocultan la
        // propia tarjeta, la padre actual y sus derivadas.
        vm.parentCardPicker = createCardPicker();
        vm.savingParentCard = false;

        function parentPickerExcludeIds() {
            var excludeIds = [String(vm.viewCard.id)];

            if (vm.viewCard.parent_card) {
                excludeIds.push(String(vm.viewCard.parent_card.id));
            }

            return excludeIds.concat(currentRelatedIds());
        }

        vm.openParentCardDropdown = function () {
            searchCardsForPicker(vm.parentCardPicker, parentPickerExcludeIds());
        };

        vm.searchParentCardToLink = function () {
            return searchCardsForPicker(vm.parentCardPicker, parentPickerExcludeIds());
        };

        function saveParentCard(parentId) {

            if (!vm.viewCard || !vm.viewCard.id || vm.savingParentCard) {
                return $q.resolve();
            }

            var cardId = vm.viewCard.id;

            vm.savingParentCard = true;

            return KanbanService.SetParentCard(cardId, parentId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Si mientras tanto se abrió otra tarjeta, no se toca.
                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.parent_card = data.parent_card || null;
                }

                vm.getHistory(cardId);

            }).catch(function (error) {

                vm.showError(tr('Could not save the parent OT.'), error);

            }).finally(function () {

                vm.savingParentCard = false;
            });
        }

        vm.linkParentCard = function (card) {

            if (!card || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            return saveParentCard(String(card.id));
        };

        vm.unlinkParentCard = function ($event) {

            if ($event) {
                $event.stopPropagation();
            }

            if (!vm.viewCard.parent_card || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            return saveParentCard(null);
        };

        // Abre el modal de nueva tarjeta para crear una derivada de la tarjeta
        // abierta (se crea en el primer estado del tablero).
        vm.openNewDerivedCardModal = function () {

            if (!vm.viewCard || !vm.viewCard.id || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            vm.openNewCardModal(null);

            vm.newCard.parent_card = {
                id: String(vm.viewCard.id),
                title: vm.viewCard.title
            };
        };

        vm.openRelatedCardsDropdown = function () {
            searchCardsForPicker(vm.relatedCardsPicker, relatedPickerExcludeIds());
        };

        vm.searchRelatedCardsToAdd = function () {
            return searchCardsForPicker(vm.relatedCardsPicker, relatedPickerExcludeIds());
        };

        function saveRelatedCards(relatedIds) {

            if (!vm.viewCard || !vm.viewCard.id || vm.savingRelatedCards) {
                return $q.resolve();
            }

            var cardId = vm.viewCard.id;

            vm.savingRelatedCards = true;

            return KanbanService.SetRelatedCards(cardId, relatedIds).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Si mientras tanto se abrió otra tarjeta, no se toca.
                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.related_cards = data.related_cards || [];
                }

                vm.getHistory(cardId);

            }).catch(function (error) {

                vm.showError(tr('Could not save the related OTs.'), error);

            }).finally(function () {

                vm.savingRelatedCards = false;
            });
        }

        vm.addRelatedCard = function (card) {

            if (!card || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            // Se quita ya de la lista del desplegable para no añadirla dos veces.
            vm.relatedCardsPicker.results = vm.relatedCardsPicker.results.filter(function (result) {
                return String(result.id) !== String(card.id);
            });

            return saveRelatedCards(currentRelatedIds().concat([String(card.id)]));
        };

        vm.removeRelatedCard = function (related, $event) {

            if ($event) {
                $event.stopPropagation();
            }

            if (!related || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            return saveRelatedCards(currentRelatedIds().filter(function (relatedId) {
                return relatedId !== String(related.id);
            }));
        };


        // Convierte horas, minutos y segundos del modal en el texto de tiempo
        // estimado que se guarda en la tarjeta (ej. "2h 30m 15s").
        vm.formatTimeEstimate = function (hours, minutes, seconds) {
            var parts = [];

            if (hours > 0) {
                parts.push(hours + 'h');
            }

            if (minutes > 0) {
                parts.push(minutes + 'm');
            }

            if (seconds > 0) {
                parts.push(seconds + 's');
            }

            return parts.join(' ');
        };

        // Descompone el texto de tiempo estimado ("2h 30m 15s") en horas,
        // minutos y segundos. El campo es texto libre: un número sin unidad
        // (tarjetas antiguas o creadas desde incidencias) se toma como horas.
        vm.parseTimeEstimate = function (value) {
            var result = { hours: 0, minutes: 0, seconds: 0 };
            var text = String(value === null || value === undefined ? '' : value).trim().toLowerCase();

            if (!text) {
                return result;
            }

            if (/^\d+([.,]\d+)?$/.test(text)) {
                var totalSeconds = Math.round(parseFloat(text.replace(',', '.')) * 3600);

                result.hours = Math.floor(totalSeconds / 3600);
                result.minutes = Math.floor((totalSeconds % 3600) / 60);
                result.seconds = totalSeconds % 60;

                return result;
            }

            var regex = /(\d+)\s*(h|m|s)/g;
            var match;

            while ((match = regex.exec(text)) !== null) {
                var amount = Number(match[1]) || 0;

                if (match[2] === 'h') {
                    result.hours += amount;
                } else if (match[2] === 'm') {
                    result.minutes += amount;
                } else {
                    result.seconds += amount;
                }
            }

            return result;
        };

        // Tiempo estimado para mostrar, siempre con su unidad (h, m, s).
        vm.getTimeEstimateLabel = function (value) {
            var time = vm.parseTimeEstimate(value);

            return vm.formatTimeEstimate(time.hours, time.minutes, time.seconds) || tr('Not specified');
        };

        vm.createCard = function () {

            var estimateHours = Number(vm.newCard.time_estimate_hours) || 0;
            var estimateMinutes = Number(vm.newCard.time_estimate_minutes) || 0;

            var card = {
                title: (vm.newCard.title || '').trim(),
                short_description: (vm.newCard.short_description || '').trim(),
                description: (vm.newCard.description || '').trim(),
                state: vm.newCard.state,
                board: vm.selectedBoard ? vm.selectedBoard.id : null,
                img: vm.newCard.img,
                time_estimate: vm.formatTimeEstimate(estimateHours, estimateMinutes),
                priority: vm.newCard.priority ? 1 : 0,
                is_recurring: vm.newCard.is_recurring ? 1 : 0,
                recurring_days: vm.newCard.is_recurring ? vm.newCard.recurring_days : 0,
                assigned_to: vm.newCard.assigned_to,
                planification_date: vm.newCard.planification_date,
                maintenance_application: vm.newCard.maintenance_application || null,
                corrective_ot: vm.newCard.corrective_ot || null,
                parent_card: vm.newCard.parent_card ? vm.newCard.parent_card.id : null
            };

            var errors = {};

            if (!card.title) {
                errors['newCard.title'] = tr('You must enter a title.');
            }

            if (!card.short_description) {
                errors['newCard.short_description'] = tr('You must enter a short description.');
            }

            if (!card.description) {
                errors['newCard.description'] = tr('You must enter a description.');
            }

            if (card.is_recurring && !card.recurring_days) {
                errors['newCard.recurring_days'] = tr('You must enter how often, in days, the OT repeats.');
            }

            if (estimateHours < 0 || estimateMinutes < 0 || estimateMinutes > 59) {
                errors['newCard.time_estimate'] = tr('You must enter a valid time.');
            }

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            KanbanService.CreateCard(card).then(function (data) {

                if (!data || !data.success || !data.card) {
                    return $q.reject(data);
                }

                vm.addCardToColumn(data.card);

                var cardId = data.card.id;

                // Derivada creada desde una tarjeta abierta: se refrescan sus
                // tarjetas derivadas y su historial.
                if (card.parent_card && data.parent_related_cards && vm.viewCard && String(vm.viewCard.id) === String(card.parent_card)) {
                    vm.viewCard.related_cards = data.parent_related_cards;
                    vm.getHistory(vm.viewCard.id);
                }

                return $q.when(vm.createAllNewTask(cardId)).then(function () {

                    // La tarjeta nace con las tareas del template de su ubicación
                    // más las añadidas en el modal: se muestra ya su barra de progreso.
                    return KanbanService.GetTasks(cardId).then(function (taskData) {

                        var tasks = (taskData && taskData.tasks) || [];

                        var finished = tasks.filter(function (task) {
                            return task.finished === 1 || task.finished === true;
                        }).length;

                        vm.updateCardProgressInBoard(cardId, finished, tasks.length);
                    }, function () {
                        // Solo afecta a la vista previa; al recargar se ve bien.
                    });
                });

            }).then(function () {

                vm.allNewTask = [];

                vm.closeNewCardModal();

            }).catch(function (error) {

                vm.showError(tr('Could not create the OT.'), error);

            });

        };

        vm.formatCardDate = function (planificationDate) {

            if (!planificationDate) {
                return tr('No date');
            }

            var date = new Date(planificationDate);

            if (isNaN(date.getTime())) {
                return tr('No date');
            }

            return date.toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        };


        // --- Arranque de máquina (machine_start) -------------------------

        vm.machineStartEdit = { editing: false, value: null, saving: false };

        // Llega como "Y-m-d H:i:s": se cambia el espacio por "T" para que
        // new Date() lo entienda en todos los navegadores (hora local).
        function parseMachineStart(value) {

            if (!value) {
                return null;
            }

            var date = new Date(String(value).replace(' ', 'T'));

            return isNaN(date.getTime()) ? null : date;
        }

        vm.formatMachineStart = function (value) {

            var date = parseMachineStart(value);

            return date ? vm.formatCardDate(date) : tr('No start-up recorded');
        };

        vm.startEditingMachineStart = function () {

            if (!vm.viewCard || vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            // Si aún no hay arranque, se propone la hora actual (sin segundos).
            var value = parseMachineStart(vm.viewCard.machine_start) || new Date();

            value.setSeconds(0, 0);

            vm.machineStartEdit = { editing: true, value: value, saving: false };
        };

        vm.cancelEditingMachineStart = function () {
            vm.machineStartEdit = { editing: false, value: null, saving: false };
        };

        // clear = true borra el arranque registrado.
        vm.saveMachineStart = function (clear) {

            if (!vm.viewCard || !vm.viewCard.id || vm.machineStartEdit.saving) {
                return;
            }

            var value = clear ? null : vm.machineStartEdit.value;

            if (!clear && !(value instanceof Date && !isNaN(value.getTime()))) {
                vm.showError(tr('Enter a valid start-up date and time.'));
                return;
            }

            var pad = function (n) { return (n < 10 ? '0' : '') + n; };

            // Hora local, en el formato en que se guarda.
            var formatted = value
                ? value.getFullYear() + '-' + pad(value.getMonth() + 1) + '-' + pad(value.getDate()) + ' ' + pad(value.getHours()) + ':' + pad(value.getMinutes()) + ':00'
                : '';

            var cardId = vm.viewCard.id;

            vm.machineStartEdit.saving = true;

            return KanbanService.SetMachineStart(cardId, formatted).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.machine_start = data.machine_start;
                }

                vm.cancelEditingMachineStart();

                vm.getHistory(cardId);

            }).catch(function (error) {

                vm.machineStartEdit.saving = false;

                vm.showError(tr('Could not save the machine start-up.'), error);
            });
        };

        vm.insertCardInOrder = function (container, cardElement, isPriority) {

            if (isPriority) {

                var firstNonPriority = container.querySelector('.kanban-card:not([data-priority="1"])');

                if (firstNonPriority) {
                    container.insertBefore(cardElement, firstNonPriority);
                    return;
                }
            }

            container.appendChild(cardElement);
        };

        vm.addCardToColumn = function (card) {

            var stateId = angular.isObject(card.state) ? card.state.id : card.state;

            var column = document.querySelector('.kanban-column[data-state-id="' + stateId + '"]');

            if (!column) {
                vm.showError(tr('The OT column was not found on the board.'));
                return;
            }

            var container = column.querySelector('.kanban-cards');

            if (!container) {
                vm.showError(tr('The OT container of the column was not found.'));
                return;
            }

            var emptyMessage = container.querySelector('.kanban-empty-message');

            if (emptyMessage) {
                emptyMessage.remove();
            }

            var isPending = !!card.expired_at && Number(card.expired_at) !== 0;
            var canApprove = isPending && !!card.can_approve;
            var isLocked = isPending && !canApprove;
            var isCancelled = vm.isCardCancelled(card);

            var assignedUsers = [];

            if (angular.isArray(card.assigned_to)) {
                assignedUsers = card.assigned_to;
            }

            var assignedText = tr('Unassigned');

            if (assignedUsers.length > 0) {
                assignedText = assignedUsers.map(function (user) { return user.name || user.id; }).join(', ');
            }

            var cardElement = document.createElement('div');

            cardElement.className = 'kanban-card bg-white rounded-3 p-2' + (isPending ? ' kanban-card-inactive' : '') + (isCancelled ? ' kanban-card-cancelled' : '');
            cardElement.setAttribute('data-card-id', card.id);
            cardElement.setAttribute('data-priority', card.priority ? '1' : '0');
            cardElement.setAttribute('draggable', isLocked ? 'false' : 'true');

            cardElement.innerHTML = `<div class="kanban-card-header d-flex justify-content-end align-items-center px-2 py-1 mb-2">
                <span class="kanban-card-id" title="${tr('OT ID')}">#${card.id}</span>
            </div>
            ${isPending ? `<div class="kanban-card-pending d-flex align-items-center justify-content-between gap-2 rounded-2 px-2 py-1 mb-2">
                <span class="d-flex align-items-center gap-1 small fw-medium text-warning-emphasis">
                    <span class="material-symbols-outlined" style="font-size:14px">hourglass_empty</span>
                    ${tr('Pending approval')}
                </span>
                ${canApprove ? `<div class="d-flex align-items-center gap-1">
                    <button type="button" class="btn btn-sm btn-outline-danger py-0 px-2 kanban-card-decline-btn">${tr('Decline')}</button>
                    <button type="button" class="btn btn-sm btn-warning py-0 px-2 kanban-card-accept-btn">${tr('Accept')}</button>
                </div>` : ''}
            </div>` : ''}
            <div class="d-flex align-items-center gap-2 mb-1">
                <div class="kanban-card-flags d-flex align-items-center gap-2">
                    ${card.priority ? `<span class="kanban-card-priority flex-shrink-0 rounded-circle bg-danger-subtle text-danger d-flex align-items-center justify-content-center" style="width:20px;height:20px" title="${tr('High priority')}">
                        <span class="material-symbols-outlined" style="font-size:14px">priority_high</span>
                    </span>` : ''}
                    ${card.is_recurring ? `<span class="kanban-card-recurrent flex-shrink-0 rounded-circle bg-light text-muted d-flex align-items-center justify-content-center" style="width:20px;height:20px" title="${tr('Recurring task')}">
                        <span class="material-symbols-outlined" style="font-size:14px">repeat</span>
                    </span>` : ''}
                </div>
                <h4 class="kanban-card-title fw-bold m-0 mb-1" style="font-size:14px">
                    ${card.title || ''}
                </h4>
                ${isCancelled ? `<span class="kanban-card-cancelled-badge badge bg-danger ms-auto flex-shrink-0">${tr('Cancelled')}</span>` : ''}
            </div>
            <p class="kanban-card-description text-muted mb-3 line-clamp-2" style="font-size:13px">
                ${card.short_description || ''}
            </p>
            <div class="d-flex align-items-center gap-1 small text-muted mb-2">
                <span class="material-symbols-outlined" style="font-size:16px">timer</span>
                <span class="kanban-card-logged-time">${card.logged_time || tr('No logged hours')}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center pt-2 border-top">
                <div class="d-flex align-items-center gap-1 small text-muted">
                    <span class="material-symbols-outlined" style="font-size:16px">schedule</span>
                    <span>${vm.formatCardDate(card.planification_date)}</span>
                </div>
                <div class="d-flex align-items-center gap-1 small text-muted">
                    <span class="material-symbols-outlined" style="font-size:16px">person</span>
                    <span>${assignedText}</span>
                </div>
            </div>`;

            vm.insertCardInOrder(container, cardElement, !!card.priority);
            vm.initCardDragAndDrop(cardElement);
            vm.initCardAcceptButton(cardElement, card.id);
            vm.updateStateCounters();
        };

        vm.initCardDragAndDrop = function (card) {

            if (card.dataset.dragInitialized) {
                return;
            }

            card.dataset.dragInitialized = 'true';

            card.addEventListener('click', function () {
                if (!draggedCard) {
                    vm.onCardClick(card);
                }
            });

            card.addEventListener('dragstart', function (event) {
                draggedCard = card;
                var cardId = card.dataset.cardId;
                card.classList.add('card-drag-shadow', 'opacity-50');
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', cardId);
            });

            card.addEventListener('dragend', function () {
                card.classList.remove('card-drag-shadow', 'opacity-50');
                document.querySelectorAll('.kanban-column').forEach(function (state) {
                    state.classList.remove('ring-2');
                });
                draggedCard = null;
            });
        };

        vm.initCardAcceptButton = function (cardElement, cardId) {

            var acceptBtn = cardElement.querySelector('.kanban-card-accept-btn');

            if (acceptBtn) {
                acceptBtn.addEventListener('click', function (event) {
                    event.stopPropagation();

                    $scope.$applyAsync(function () {
                        vm.acceptCard(cardId);
                    });
                });
            }

            var declineBtn = cardElement.querySelector('.kanban-card-decline-btn');

            if (declineBtn) {
                declineBtn.addEventListener('click', function (event) {
                    event.stopPropagation();

                    $scope.$applyAsync(function () {
                        vm.declineCard(cardId);
                    });
                });
            }
        };

        vm.acceptCard = function (cardId) {

            vm.askConfirm({
                title: tr('Accept action'),
                message: tr('Are you sure you want to accept the pending action of OT #{id}?', { id: cardId }),
                confirmLabel: tr('Accept'),
                icon: 'task_alt',
                variant: 'primary',
                onConfirm: function () {
                    return vm.executeAcceptCard(cardId);
                }
            });
        };

        vm.executeAcceptCard = function (cardId) {

            return KanbanService.AcceptCard(cardId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.updateCardInBoard(data.card);

                return data;

            }).catch(function (error) {

                vm.showError(tr('Could not accept the action.'), error);
            });
        };

        vm.declineCard = function (cardId) {

            vm.askConfirm({
                title: tr('Decline action'),
                message: tr('Are you sure you want to decline the pending action of OT #{id}?', { id: cardId }),
                confirmLabel: tr('Decline'),
                icon: 'block',
                variant: 'danger',
                onConfirm: function () {
                    return vm.executeDeclineCard(cardId);
                }
            });
        };

        vm.executeDeclineCard = function (cardId) {

            return KanbanService.DeclineCard(cardId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.updateCardInBoard(data.card);

                return data;

            }).catch(function (error) {

                vm.showError(tr('Could not decline the action.'), error);
            });
        };

        vm.editCard = {
            title: '',
            short_description: '',
            description: '',
            state: null,
            img: null,
            time_estimate: '',
            priority: false,
            is_recurring: false,
            recurring_days: null,
            assigned_to: [],
            planification_date: null
        };

        vm.updateCard = function () {

            var card = {
                id: vm.editCard.id,
                title: (vm.editCard.title || '').trim(),
                short_description: (vm.editCard.short_description || '').trim(),
                description: (vm.editCard.description || '').trim(),
                state: vm.editCard.state,
                img: vm.editCard.img ?? null,
                time_estimate: vm.formatTimeEstimate(
                    Number(vm.editCard.time_estimate_hours) || 0,
                    Number(vm.editCard.time_estimate_minutes) || 0,
                    Number(vm.editCard.time_estimate_seconds) || 0
                ),
                priority: vm.editCard.priority ? 1 : 0,
                is_recurring: vm.editCard.is_recurring ? 1 : 0,
                recurring_days: vm.editCard.is_recurring ? vm.editCard.recurring_days : 0,
                assigned_to: vm.selectedUsers,
                planification_date: formatDateForBackend(vm.editCard.planification_date),
                machine: vm.editCard.machine || null,
                line: vm.editCard.line || null,
                maintenance_application: vm.editCard.maintenance_application || null,
                corrective_ot: vm.editCard.corrective_ot || null
            };

            var errors = {};

            if (!card.title) {
                errors['editCard.title'] = tr('You must enter a title.');
            }

            if (!card.short_description) {
                errors['editCard.short_description'] = tr('You must enter a short description.');
            }

            if (!card.description) {
                errors['editCard.description'] = tr('You must enter a description.');
            }

            if (card.is_recurring && !card.recurring_days) {
                errors['editCard.recurring_days'] = tr('You must enter how often, in days, the OT repeats.');
            }

            if (!vm.setFieldErrors(errors)) {
                return $q.reject({ isValidation: true });
            }

            return KanbanService.UpdateCard(card).then(function (data) {

                if (!data.success) {
                    return $q.reject(data);
                }

                // Actualizamos el modal de visualización
                vm.editCard.time_estimate = card.time_estimate;
                vm.viewCard = angular.copy(vm.editCard);

                vm.viewCard.assigned_to = [];

                (vm.selectedUsers || []).forEach(function (userId) {

                    var user = vm.allUsers.find(function (u) {
                        return String(u.id) === String(userId);
                    });

                    if (user) {
                        vm.viewCard.assigned_to.push(user);
                    }
                });

                // Actualizamos la tarjeta del Kanban
                vm.updateCardInBoard(vm.viewCard);

                // La información general se calcula en el servidor a partir de
                // la máquina, el historial de línea y el tipo de solicitud,
                // así que se vuelve a pedir la tarjeta para refrescarla.
                return vm.refreshViewCardGeneralInfo(card.id).then(function () {
                    return data;
                });
            });
        };

        vm.refreshViewCardGeneralInfo = function (cardId) {

            return vm.getCard(cardId).then(function (response) {

                if (!response || !response.success || !response.card) {
                    return $q.reject(response);
                }

                vm.viewCard.general_info = response.card.general_info;
                vm.viewCard.machine = response.card.machine;
                vm.viewCard.line = response.card.line;
                vm.viewCard.maintenance_application = response.card.maintenance_application;
                vm.viewCard.corrective_ot = response.card.corrective_ot;

            }).catch(function (error) {

                vm.showError(tr('The OT was saved, but the general information could not be refreshed.'), error);
            });
        };

        // ------------------------------------------------------------------
        // Edición de la información general: Máquina, Línea (historial de la
        // incidencia, line_history) y Tipo de solicitud de mantenimiento.
        // ------------------------------------------------------------------

        vm.machines = [];
        vm.machineSearchTerm = '';
        vm.lineHistories = [];
        vm.loadingLineHistories = false;

        // Id de una relación como texto (o null). Los ids se normalizan a texto
        // porque ng-options compara con === y pueden llegar como número o texto.
        function toNodeId(value) {
            var id = angular.isObject(value) ? value.id : value;

            return id ? String(id) : null;
        }

        function withStringIds(items) {
            return (items || []).map(function (item) {
                return angular.extend({}, item, { id: String(item.id) });
            });
        }

        vm.getMachines = function () {
            return KanbanService.GetMachines().then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.machines = withStringIds(data.machines);

                return vm.machines;

            }).catch(function (error) {

                vm.showError(tr('Could not get the machines.'), error);
            });
        };

        vm.getSelectedMachine = function () {

            if (!vm.editCard || !vm.editCard.machine) {
                return null;
            }

            return vm.machines.find(function (machine) {
                return String(machine.id) === String(vm.editCard.machine);
            }) || null;
        };

        vm.getSelectedMachineName = function () {
            var machine = vm.getSelectedMachine();

            return machine ? machine.name : '';
        };

        vm.isMachineSelected = function (machine) {
            return !!vm.editCard && String(vm.editCard.machine) === String(machine.id);
        };

        vm.selectMachine = function (machine, event) {

            var previousMachine = vm.getSelectedMachine();

            vm.editCard.machine = machine ? machine.id : null;

            vm.closeDropdown(event);

            // Si la nueva máquina es de otra línea, el historial elegido ya no
            // corresponde: se quita y se cargan los de la nueva línea.
            var previousLine = previousMachine ? previousMachine.production_line : null;
            var newLine = machine ? machine.production_line : null;

            if (String(previousLine) !== String(newLine)) {
                vm.editCard.line = null;
            }

            vm.getLineHistories();
        };

        vm.getLineHistories = function () {

            var machine = vm.getSelectedMachine();

            vm.loadingLineHistories = true;

            return KanbanService.GetLineHistories(machine ? machine.production_line : null, vm.editCard.line).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.lineHistories = withStringIds(data.histories);

                return vm.lineHistories;

            }).catch(function (error) {

                vm.showError(tr('Could not get the line histories.'), error);

            }).finally(function () {

                vm.loadingLineHistories = false;
            });
        };

        vm.loadGeneralInfoOptions = function () {

            vm.machineSearchTerm = '';

            vm.getMaintenanceApplications();
            vm.getCorrectiveOts();

            // Los historiales dependen de la línea de la máquina, así que se
            // cargan después de tener las máquinas.
            return $q.when(vm.machines.length ? vm.machines : vm.getMachines()).then(function () {
                return vm.getLineHistories();
            });
        };

        function formatDateForBackend(date) {
            if (!date) {
                return null;
            }

            var d = new Date(date);

            var year = d.getFullYear();
            var month = String(d.getMonth() + 1).padStart(2, '0');
            var day = String(d.getDate()).padStart(2, '0');
            var hours = String(d.getHours()).padStart(2, '0');
            var minutes = String(d.getMinutes()).padStart(2, '0');
            var seconds = String(d.getSeconds()).padStart(2, '0');

            return year + '-' + month + '-' + day + ' ' +
                hours + ':' + minutes + ':' + seconds;
        }

        vm.updateCardInBoard = function (card) {

            var cardElement = document.querySelector('.kanban-card[data-card-id="' + card.id + '"]');

            if (!cardElement) {
                vm.showError(tr('OT #{id} was not found on the board.', { id: card.id }));
                return;
            }

            var stateId = angular.isObject(card.state) ? card.state.id : card.state;

            var assignedUsers = [];

            if (angular.isArray(card.assigned_to)) {
                assignedUsers = card.assigned_to;
            }

            var assignedText = tr('Unassigned');

            if (assignedUsers.length > 0) {
                assignedText = assignedUsers.map(function (user) { return user.name || user.id; }).join(', ');
            }

            var existingLoggedTimeEl = cardElement.querySelector('.kanban-card-logged-time');
            var loggedTimeText = existingLoggedTimeEl ? existingLoggedTimeEl.textContent.trim() : tr('No logged hours');

            var isPending = !!card.expired_at && Number(card.expired_at) !== 0;
            var canApprove = isPending && !!card.can_approve;
            var isLocked = isPending && !canApprove;
            var isCancelled = vm.isCardCancelled(card);

            var existingProgressEl = cardElement.querySelector('.kanban-card-progress');
            var progressHtml = existingProgressEl ? existingProgressEl.outerHTML : '';

            cardElement.className = 'kanban-card bg-white rounded-3 p-2' + (isPending ? ' kanban-card-inactive' : '') + (isCancelled ? ' kanban-card-cancelled' : '');

            cardElement.innerHTML = `<div class="kanban-card-header d-flex justify-content-end align-items-center px-2 py-1 mb-2">
                <span class="kanban-card-id" title="${tr('OT ID')}">#${card.id}</span>
            </div>
            ${isPending ? `<div class="kanban-card-pending d-flex align-items-center justify-content-between gap-2 rounded-2 px-2 py-1 mb-2">
                <span class="d-flex align-items-center gap-1 small fw-medium text-warning-emphasis">
                    <span class="material-symbols-outlined" style="font-size:14px">hourglass_empty</span>
                    ${tr('Pending approval')}
                </span>
                ${canApprove ? `<div class="d-flex align-items-center gap-1">
                    <button type="button" class="btn btn-sm btn-outline-danger py-0 px-2 kanban-card-decline-btn">${tr('Decline')}</button>
                    <button type="button" class="btn btn-sm btn-warning py-0 px-2 kanban-card-accept-btn">${tr('Accept')}</button>
                </div>` : ''}
            </div>` : ''}
            <div class="d-flex align-items-center gap-2 mb-1">
                <div class="kanban-card-flags d-flex align-items-center gap-2">
                    ${card.priority ? `<span class="kanban-card-priority flex-shrink-0 rounded-circle bg-danger-subtle text-danger d-flex align-items-center justify-content-center" style="width:20px;height:20px" title="${tr('High priority')}">
                        <span class="material-symbols-outlined" style="font-size:14px">priority_high</span>
                    </span>` : ''}
                    ${card.is_recurring ? `<span class="kanban-card-recurrent flex-shrink-0 rounded-circle bg-light text-muted d-flex align-items-center justify-content-center" style="width:20px;height:20px" title="${tr('Recurring task')}">
                        <span class="material-symbols-outlined" style="font-size:14px">repeat</span>
                    </span>` : ''}
                </div>
                <h4 class="kanban-card-title fw-bold m-0 mb-1" style="font-size:14px">
                    ${card.title || ''}
                </h4>
                ${isCancelled ? `<span class="kanban-card-cancelled-badge badge bg-danger ms-auto flex-shrink-0">${tr('Cancelled')}</span>` : ''}
            </div>
            <p class="kanban-card-description text-muted mb-3 line-clamp-2" style="font-size:13px">
                ${card.short_description || ''}
            </p>
            ${progressHtml}
            <div class="d-flex align-items-center gap-1 small text-muted mb-2">
                <span class="material-symbols-outlined" style="font-size:16px">timer</span>
                <span class="kanban-card-logged-time">${loggedTimeText}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center pt-2 border-top">
                <div class="d-flex align-items-center gap-1 small text-muted">
                    <span class="material-symbols-outlined" style="font-size:16px">schedule</span>
                    <span>${vm.formatCardDate(card.planification_date)}</span>
                </div>
                <div class="d-flex align-items-center gap-1 small text-muted">
                    <span class="material-symbols-outlined" style="font-size:16px">person</span>
                    <span>${assignedText}</span>
                </div>
            </div>`;

            cardElement.setAttribute('data-card-id', card.id);
            cardElement.setAttribute('draggable', isLocked ? 'false' : 'true');
            cardElement.setAttribute('data-priority', card.priority ? '1' : '0');

            vm.initCardDragAndDrop(cardElement);
            vm.initCardAcceptButton(cardElement, card.id);

            var currentColumn = cardElement.closest('.kanban-column');
            var targetColumn = currentColumn;

            if (stateId !== null && stateId !== undefined) {

                var newColumn = document.querySelector('.kanban-column[data-state-id="' + stateId + '"]');

                if (newColumn) {
                    targetColumn = newColumn;
                }
            }

            if (targetColumn) {

                var targetContainer = targetColumn.querySelector('.kanban-cards');

                if (targetContainer) {

                    var emptyMessage = targetContainer.querySelector('.kanban-empty-message');

                    if (emptyMessage) {
                        emptyMessage.remove();
                    }

                    cardElement.remove();
                    vm.insertCardInOrder(targetContainer, cardElement, !!card.priority);

                    vm.updateEmptyMessage(targetColumn);

                    if (currentColumn && currentColumn !== targetColumn) {
                        vm.updateEmptyMessage(currentColumn);
                    }
                }
            }

            vm.updateStateCounters();
        };

        vm.isViewCardModalOpen = false;

        vm.viewCard = {};

        vm.openViewCardModal = function (card) {

            vm.viewCard = angular.copy(card);

            // Si se abre otra tarjeta con el modal ya abierto (tarjetas
            // relacionadas), no se arrastra la edición de la anterior.
            vm.isEditingViewCard = false;
            vm.resetFieldErrors();

            vm.relatedCardsPicker = createCardPicker();
            vm.parentCardPicker = createCardPicker();
            vm.cancelEditingMachineStart();

            vm.isTaskView = false;
            vm.isResourcesView = false;
            vm.cardDetailTab = 'history';
            vm.openTaskInterventions = {};

            vm.isViewCardModalOpen = true;
        };

        // Pestaña activa bajo la descripción del modal de la tarjeta:
        // 'history' | 'comments' | 'attachments' | 'related'.
        vm.cardDetailTab = 'history';

        vm.setCardDetailTab = function (tab) {
            vm.cardDetailTab = tab;
        };

        vm.closeViewCardModal = function () {
            vm.isViewCardModalOpen = false;
            vm.isEditingViewCard = false;
            vm.isTaskView = false;
            vm.isResourcesView = false;

            vm.resetFieldErrors();
        };

        vm.onCardClick = function (cardElement) {
            return vm.openCardById(cardElement.dataset.cardId);
        };

        // Abre el modal de la tarjeta indicada (desde el tablero o desde la
        // pestaña "Tarjetas relacionadas" de otra tarjeta).
        vm.openCardById = function (cardId) {

            if (!cardId) {
                return;
            }

            return vm.getCard(cardId).then(function (response) {

                if (!response || !response.success) {
                    vm.showError(tr('Could not get OT #{id}.', { id: cardId }), response);
                    return;
                }

                var card = response.card;

                if (!card) {
                    vm.showError(tr('OT #{id} was not found.', { id: cardId }));
                    return;
                }

                vm.openViewCardModal(card);
                vm.getComments(cardId);
                vm.getHistory(cardId)
                vm.calculateCompletionPercentage();
            });
        };

        // ?card=id (p. ej. desde el calendario de órdenes de trabajo): abre esa
        // tarjeta al cargar el tablero.
        var cardIdFromUrl = new URLSearchParams(window.location.search).get('card');

        if (cardIdFromUrl) {
            vm.openCardById(cardIdFromUrl);
        }

        vm.isTaskView = false;

        vm.startCard = function (cardId) {

            if (vm.isCardCancelled(vm.viewCard)) {
                return;
            }

            vm.isTaskView = true;
        }

        // Vista "Recursos" del modal de la tarjeta (igual que la de tareas:
        // sustituye el contenido del modal hasta pulsar "Volver a la tarjeta").
        vm.isResourcesView = false;

        vm.openResources = function () {
            vm.isTaskView = false;
            vm.isResourcesView = true;
        };

        vm.closeResources = function () {
            vm.isResourcesView = false;
        };

        // ------------------------------------------------------------------
        // Nueva requisición (peticiones de almacén) desde la vista Recursos.
        // Se crea una petición por pieza y se enlazan al campo "request".
        // ------------------------------------------------------------------

        vm.isRequisitionModalOpen = false;
        vm.savingRequisition = false;
        vm.warehouses = [];
        // Centros de costo de SAP (Dimensión 2): [{code, name}].
        vm.costCenters = [];
        vm.requisition = null;
        vm.requisitionSearch = { origin: '', destination: '', requestedBy: '', costCenter: '' };

        // Cada pieza de la requisición busca por su cuenta en el servidor
        // (hay demasiadas piezas para cargar el catálogo entero): guarda sus
        // resultados, si está buscando y la etiqueta de la pieza elegida.
        // Piezas que se piden al servidor por página: al desplegar se cargan
        // las primeras y al llegar al final del scroll, las siguientes.
        var PETITION_PRODUCTS_PAGE = 30;

        function newRequisitionItem(isService) {
            return {
                // Servicio (productos de tipo SERVICIOS) o pieza del almacén.
                isService: !!isService,
                product_id: null,
                product_label: '',
                quantity: null,
                search: '',
                results: [],
                offset: 0,
                hasMore: false,
                loading: false,
                loaded: false,
                requestId: 0
            };
        }

        // Carga una página de piezas. reset = true empieza de cero (nueva
        // búsqueda); si no, añade la página siguiente a la lista.
        function loadPetitionProducts(item, reset) {

            var requestId = ++item.requestId;
            var offset = reset ? 0 : item.offset;

            item.loading = true;

            // Solo piezas con stock en el almacén de origen elegido; los
            // servicios no dependen del almacén.
            var warehouseId = vm.requisition ? vm.requisition.warehouse_id : null;

            var request = item.isService
                ? KanbanService.GetServiceProducts(item.search, offset, PETITION_PRODUCTS_PAGE)
                : KanbanService.GetPetitionProducts(item.search, offset, PETITION_PRODUCTS_PAGE, warehouseId);

            return request.then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Se descartan las respuestas de búsquedas ya superadas.
                if (requestId !== item.requestId) {
                    return;
                }

                var page = withStringIds(data.products);

                if (reset) {
                    item.results = page;
                } else {
                    // Una pieza puede llegar repetida en otra página (si
                    // coincide por nombre y por código): se descarta.
                    var known = {};

                    item.results.forEach(function (product) {
                        known[product.id] = true;
                    });

                    item.results = item.results.concat(page.filter(function (product) {
                        return !known[product.id];
                    }));
                }

                item.offset = offset + PETITION_PRODUCTS_PAGE;
                item.hasMore = !!data.has_more;
                item.loaded = true;

            }).catch(function (error) {

                if (requestId === item.requestId) {
                    vm.showError(tr(item.isService ? 'Could not search the services.' : 'Could not search the parts.'), error);
                }

            }).finally(function () {

                if (requestId === item.requestId) {
                    item.loading = false;
                }
            });
        }

        // Nueva búsqueda (al escribir): vuelve a la primera página.
        vm.searchPetitionProducts = function (item) {
            return loadPetitionProducts(item, true);
        };

        // Al llegar al final de la lista se pide la página siguiente.
        vm.showMorePetitionProducts = function (item) {
            if (item.hasMore && !item.loading) {
                loadPetitionProducts(item, false);
            }
        };

        // Al cambiar el almacén de origen las piezas ya elegidas o cargadas
        // pueden no estar en él: se vacían y se vuelven a pedir al desplegar.
        function resetRequisitionProducts() {

            if (!vm.requisition) {
                return;
            }

            vm.requisition.items.forEach(function (item) {
                item.product_id = null;
                item.product_label = '';
                item.results = [];
                item.offset = 0;
                item.hasMore = false;
                item.loaded = false;
                item.loading = false;
                // Descarta las respuestas pendientes del almacén anterior.
                item.requestId++;
            });
        }

        // Al abrir el desplegable por primera vez se carga la primera página,
        // sin esperar a que se escriba nada.
        vm.openPetitionProductDropdown = function (item) {
            if (!item.loaded && !item.loading) {
                loadPetitionProducts(item, true);
            }
        };

        // Almacén de origen por defecto de la requisición: WarehouseCode "07".
        var DEFAULT_REQUISITION_WAREHOUSE_CODE = '07';

        function setDefaultRequisitionWarehouse() {

            if (!vm.requisition || vm.requisition.warehouse_id) {
                return;
            }

            var warehouse = vm.warehouses.filter(function (candidate) {
                return String(candidate.code || '').trim() === DEFAULT_REQUISITION_WAREHOUSE_CODE;
            })[0];

            if (warehouse) {
                vm.requisition.warehouse_id = String(warehouse.id);
                resetRequisitionProducts();
                clearDestinationIfSameAsOrigin();
            }
        }

        // Mismo almacén: mismo id o mismo código de SAP.
        function isSameWarehouse(warehouseA, warehouseB) {

            if (!warehouseA || !warehouseB) {
                return false;
            }

            var codeA = String(warehouseA.code || '').trim().toLowerCase();
            var codeB = String(warehouseB.code || '').trim().toLowerCase();

            return String(warehouseA.id) === String(warehouseB.id) || (codeA !== '' && codeA === codeB);
        }

        // La lista de almacenes de destino no incluye el de origen.
        vm.isRequisitionDestinationCandidate = function (warehouse) {
            return !vm.requisition || !isSameWarehouse(warehouse, findById(vm.warehouses, vm.requisition.warehouse_id));
        };

        function clearDestinationIfSameAsOrigin() {

            var origin = findById(vm.warehouses, vm.requisition.warehouse_id);
            var destination = findById(vm.warehouses, vm.requisition.warehousedestiny_id);

            if (isSameWarehouse(origin, destination)) {
                vm.requisition.warehousedestiny_id = null;
            }
        }

        // Al salir del campo la cantidad se deja entera: se quita la parte
        // decimal y si es menor que 1 se pone a 1.
        vm.normalizeRequisitionQuantity = function (item, index) {

            if (item.quantity === null || item.quantity === undefined || item.quantity === '') {
                return;
            }

            var quantity = Math.trunc(Number(item.quantity));

            if (isNaN(quantity)) {
                return;
            }

            item.quantity = quantity < 1 ? 1 : quantity;
            vm.clearFieldError('requisition.' + (item.isService ? 'services' : 'items') + '.' + index + '.quantity');
        };

        vm.openRequisitions = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            vm.requisition = {
                warehouse_id: null,
                warehousedestiny_id: null,
                cost_center: null,
                // 'parts' o 'services': por defecto, piezas.
                type: 'parts',
                requested_by_id: null,
                observations: '',
                items: [newRequisitionItem()],
                services: [newRequisitionItem(true)]
            };

            vm.requisitionSearch = { origin: '', destination: '', requestedBy: '', costCenter: '' };

            vm.resetFieldErrors();

            vm.isRequisitionModalOpen = true;

            vm.getUsers();

            if (!vm.costCenters.length) {
                KanbanService.GetCostCenters().then(function (data) {
                    if (!data || !data.success) {
                        return $q.reject(data);
                    }
                    vm.costCenters = data.cost_centers || [];
                }).catch(function (error) {
                    vm.showError(tr('Could not get the cost centers.'), error);
                });
            }

            if (!vm.warehouses.length) {
                KanbanService.GetWarehouses().then(function (data) {
                    if (!data || !data.success) {
                        return $q.reject(data);
                    }
                    vm.warehouses = withStringIds(data.warehouses);
                    setDefaultRequisitionWarehouse();
                }).catch(function (error) {
                    vm.showError(tr('Could not get the warehouses.'), error);
                });
            } else {
                setDefaultRequisitionWarehouse();
            }

            // Por defecto lo pide la persona del usuario conectado.
            KanbanService.GetCurrentPersonal().then(function (data) {
                if (data && data.success && data.personal && vm.requisition && !vm.requisition.requested_by_id) {
                    vm.requisition.requested_by_id = String(data.personal.id);
                }
            });
        };

        vm.closeRequisitionModal = function () {
            vm.isRequisitionModalOpen = false;
            vm.requisition = null;
            vm.resetFieldErrors();
        };

        vm.addRequisitionItem = function () {
            vm.requisition.items.push(newRequisitionItem());
        };

        vm.removeRequisitionItem = function (index) {

            if (vm.requisition.items.length <= 1) {
                return;
            }

            vm.requisition.items.splice(index, 1);

            // Los errores de las piezas van por posición: se recalculan al guardar.
            Object.keys(vm.fieldErrors).forEach(function (key) {
                if (key.indexOf('requisition.items.') === 0) {
                    delete vm.fieldErrors[key];
                }
            });
        };

        vm.addRequisitionService = function () {
            vm.requisition.services.push(newRequisitionItem(true));
        };

        vm.removeRequisitionService = function (index) {

            if (vm.requisition.services.length <= 1) {
                return;
            }

            vm.requisition.services.splice(index, 1);

            // Los errores de los servicios van por posición: se recalculan al guardar.
            Object.keys(vm.fieldErrors).forEach(function (key) {
                if (key.indexOf('requisition.services.') === 0) {
                    delete vm.fieldErrors[key];
                }
            });
        };

        function findById(list, id) {
            return (list || []).find(function (item) {
                return String(item.id) === String(id);
            }) || null;
        }

        vm.getWarehouseLabel = function (id) {
            var warehouse = findById(vm.warehouses, id);

            return warehouse ? warehouse.name + (warehouse.code ? ' (' + warehouse.code + ')' : '') : '';
        };

        vm.getCostCenterLabel = function (code) {
            var costCenter = (vm.costCenters || []).find(function (item) {
                return String(item.code) === String(code);
            });

            return costCenter ? costCenter.name + ' (' + costCenter.code + ')' : code;
        };

        vm.getRequisitionPersonLabel = function (id) {
            return vm.getUserFullName(findById(vm.allUsers, id));
        };

        vm.selectRequisitionField = function (field, value, errorKey, event) {

            var warehouseChanged = field === 'warehouse_id' && String(vm.requisition.warehouse_id) !== String(value);

            vm.requisition[field] = value;

            if (warehouseChanged) {
                resetRequisitionProducts();
                clearDestinationIfSameAsOrigin();
            }
            vm.clearFieldError(errorKey);
            vm.closeDropdown(event);
        };

        vm.selectRequisitionType = function (type) {
            vm.requisition.type = type;
            vm.clearFieldError('requisition.type');
        };

        vm.selectRequisitionProduct = function (item, index, product, event) {
            item.product_id = product.id;
            item.product_label = product.name + (product.itemcode ? ' · ' + product.itemcode : '');
            vm.clearFieldError('requisition.' + (item.isService ? 'services' : 'items') + '.' + index + '.product');
            vm.closeDropdown(event);
        };

        vm.saveRequisition = function () {

            var requisition = vm.requisition;
            var errors = {};

            if (!requisition.warehouse_id) {
                errors['requisition.warehouse_id'] = tr('You must select the source warehouse.');
            }

            // Sin destino es una recogida: el destino es opcional.
            if (requisition.warehousedestiny_id && isSameWarehouse(findById(vm.warehouses, requisition.warehouse_id), findById(vm.warehouses, requisition.warehousedestiny_id))) {
                errors['requisition.warehousedestiny_id'] = tr('The source and destination warehouses cannot be the same.');
            }

            if (!requisition.requested_by_id) {
                errors['requisition.requested_by_id'] = tr('You must indicate who is making the request.');
            }

            if (!requisition.cost_center) {
                errors['requisition.cost_center'] = tr('You must select a cost center.');
            }

            if (!requisition.type) {
                errors['requisition.type'] = tr('You must indicate whether the requisition is for parts or services.');
            } else if (requisition.type === 'services') {
                // Los servicios ya se pueden elegir, pero todavía no se envían.
                errors['requisition.type'] = tr('Services cannot be requested yet.');
            }

            (requisition.type === 'parts' ? requisition.items : []).forEach(function (item, index) {

                if (!item.product_id) {
                    errors['requisition.items.' + index + '.product'] = tr('You must select a part.');
                }

                var quantity = Number(item.quantity);

                if (!quantity || quantity < 1 || Math.floor(quantity) !== quantity) {
                    errors['requisition.items.' + index + '.quantity'] = tr('Enter a whole quantity of at least 1.');
                }
            });

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            var cardId = vm.viewCard.id;

            var payload = {
                cardID: cardId,
                warehouse_id: requisition.warehouse_id,
                warehousedestiny_id: requisition.warehousedestiny_id,
                cost_center: requisition.cost_center,
                requested_by_id: requisition.requested_by_id,
                observations: (requisition.observations || '').trim(),
                items: requisition.items.map(function (item) {
                    return { product_id: item.product_id, quantity: Number(item.quantity) };
                })
            };

            vm.savingRequisition = true;

            return KanbanService.CreateCardPetition(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.warehouse_requests = data.warehouse_requests || [];
                    vm.getHistory(cardId);
                }

                vm.closeRequisitionModal();

                // Alguna pieza pudo fallar (p. ej. en SAP) aunque se crearan otras.
                if (data.errors && data.errors.length) {
                    vm.showError(tr('The requisition was created, but there were problems with some parts.'), { message: data.errors.concat(data.warnings || []).join(' ') });
                } else if (data.warnings && data.warnings.length) {
                    // P. ej. las observaciones se cortaron a 254 caracteres.
                    vm.showError(tr('The requisition was created with a notice.'), { message: data.warnings.join(' ') });
                }

            }).catch(function (error) {

                var detail = error && error.data && error.data.errors && error.data.errors.length
                    ? { message: error.data.errors.join(' ') }
                    : error;

                vm.showError(tr('Could not create the requisition.'), detail);

            }).finally(function () {

                vm.savingRequisition = false;
            });
        };

        // ------------------------------------------------------------------
        // Devolución de una petición de almacén: misma pieza, almacenes al
        // revés y cantidad entre 1 y la pedida en la petición original.
        // ------------------------------------------------------------------

        vm.isReturnModalOpen = false;
        vm.savingReturn = false;
        vm.returnRequest = null;
        vm.returnSearch = { requestedBy: '' };

        vm.openReturnModal = function (request) {

            // Solo se devuelven peticiones completadas que no sean devoluciones
            // y a las que les quede cantidad por devolver.
            if (!vm.viewCard || !vm.viewCard.id || !request || !request.id || !request.completed || request.kind === 'pickup_return' || request.is_return || !(request.returnable_quantity > 0)) {
                return;
            }

            // Una recogida (sin destino) se devuelve con una entrada de
            // mercancías al almacén del que salió la pieza.
            var isPickup = request.kind === 'pickup';

            vm.returnRequest = {
                request_id: request.id,
                is_pickup: isPickup,
                product: request.product || request.title || tr('Unspecified part'),
                product_code: request.product_code,
                // Al revés que en la petición original.
                origin: isPickup ? tr('Picked up part (no warehouse)') : request.destination,
                destination: request.origin,
                // Lo pedido menos lo ya devuelto
                max_quantity: Number(request.returnable_quantity) || 0,
                quantity: Number(request.returnable_quantity) || 1,
                requested_by_id: null,
                observations: tr('Return of request #{id}.', { id: request.id })
            };

            vm.returnSearch = { requestedBy: '' };

            vm.resetFieldErrors();

            vm.isReturnModalOpen = true;

            vm.getUsers();

            // Por defecto lo pide la persona del usuario conectado.
            KanbanService.GetCurrentPersonal().then(function (data) {
                if (data && data.success && data.personal && vm.returnRequest && !vm.returnRequest.requested_by_id) {
                    vm.returnRequest.requested_by_id = String(data.personal.id);
                }
            });
        };

        vm.closeReturnModal = function () {
            vm.isReturnModalOpen = false;
            vm.returnRequest = null;
            vm.resetFieldErrors();
        };

        vm.selectReturnRequestedBy = function (userId, event) {
            vm.returnRequest.requested_by_id = userId;
            vm.clearFieldError('returnRequest.requested_by_id');
            vm.closeDropdown(event);
        };

        vm.saveReturn = function () {

            var returnRequest = vm.returnRequest;
            var errors = {};
            var quantity = Number(returnRequest.quantity);

            if (!quantity || quantity < 1 || quantity > returnRequest.max_quantity || Math.floor(quantity) !== quantity) {
                errors['returnRequest.quantity'] = tr('Enter a whole quantity between 1 and {max}.', { max: returnRequest.max_quantity });
            }

            if (!returnRequest.requested_by_id) {
                errors['returnRequest.requested_by_id'] = tr('You must indicate who is making the return.');
            }

            if (!vm.setFieldErrors(errors)) {
                return;
            }

            var cardId = vm.viewCard.id;

            var payload = {
                cardID: cardId,
                requestID: returnRequest.request_id,
                quantity: quantity,
                requested_by_id: returnRequest.requested_by_id,
                observations: (returnRequest.observations || '').trim()
            };

            vm.savingReturn = true;

            return KanbanService.CreateCardReturn(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.warehouse_requests = data.warehouse_requests || [];
                    vm.getHistory(cardId);
                }

                vm.closeReturnModal();

                // Se creó en el CRM, pero pudo fallar SAP o el enlace a la tarjeta.
                if (data.errors && data.errors.length) {
                    vm.showError(tr('The return was created, but there were problems processing it.'),{ message: data.errors.join(' ') });
                }

            }).catch(function (error) {

                var detail = error && error.data && error.data.errors && error.data.errors.length
                    ? { message: error.data.errors.join(' ') }
                    : error;

                vm.showError(tr('Could not create the return.'), detail);

            }).finally(function () {

                vm.savingReturn = false;
            });
        };

        // Las tareas llegan por orden de creación: hasta que la primera esté
        // terminada no se puede empezar ninguna otra.
        vm.isTaskLocked = function (task) {

            var firstTask = (vm.tasks && vm.tasks.length) ? vm.tasks[0] : null;

            if (!task || !firstTask || String(firstTask.id) === String(task.id)) {
                return false;
            }

            return !(firstTask.finished === 1 || firstTask.finished === true || firstTask.finished === '1');
        };

        vm.startTask = function (task) {

            if (!task || !task.id || vm.isTaskLocked(task)) {
                return;
            }

            return KanbanService.StartTask(task.id).then(function (response) {

                if (!response || !response.success) {
                    return $q.reject(response);
                }

                task.started = true;
                task.finished = false;
                task.start_time = response.task.start_time;

                angular.extend(task, response.task);

                return response.task;

            }).catch(function (error) {

                vm.showError(tr('Could not start the task.'), error);

                return $q.reject(error);
            });
        };

        vm.endTask = function (task) {

            if (!task || !task.id) {
                return;
            }

            return KanbanService.EndTask({ taskID: task.id, intervention: task.intervention, user: vm.currentUser.id || '' }).then(function (response) {

                if (!response || !response.success) {
                    return $q.reject(response);
                }

                var updatedTask = response.task;

                if (!updatedTask) {
                    return $q.reject({ message: tr('Task not found.') });
                }

                // Actualizamos la tarea del ng-repeat
                angular.extend(task, updatedTask);

                task.finished = true;

                // Se recalcula con las tareas ya cargadas (sin pedirlas de nuevo,
                // para no perder lo que se esté escribiendo en otras tareas).
                updateCompletion(vm.tasks);

                return updatedTask;

            }).catch(function (error) {

                vm.showError(tr('Could not finish the task.'), error);

                return $q.reject(error);
            });
        };

        // Tareas finalizadas con la intervención desplegada (por id, para que
        // se mantenga aunque se recargue la lista de tareas).
        vm.openTaskInterventions = {};

        vm.isTaskInterventionOpen = function (task) {
            return !!task && !!vm.openTaskInterventions[task.id];
        };

        vm.toggleTaskIntervention = function (task) {

            if (!task || !task.id) {
                return;
            }

            vm.openTaskInterventions[task.id] = !vm.openTaskInterventions[task.id];
        };

        vm.deleteTask = function (task) {

            if (!task || !task.id) {
                return;
            }

            vm.askConfirm({
                title: tr('Delete task'),
                message: tr('Are you sure you want to delete the task {title}?', { title: '"' + (task.title || '') + '"' }),
                confirmLabel: tr('Delete task'),
                icon: 'delete',
                variant: 'danger',
                onConfirm: function () {
                    return vm.executeDeleteTask(task);
                }
            });
        };

        vm.executeDeleteTask = function (task) {

            return KanbanService.DeleteTask(task.id).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                var taskIndex = vm.tasks.indexOf(task);

                if (taskIndex !== -1) {
                    vm.tasks.splice(taskIndex, 1);
                }

                refreshViewCardHistory(vm.viewCard && vm.viewCard.id);

                return vm.calculateCompletionPercentage();

            }).catch(function (error) {

                vm.showError(tr('Could not delete the task.'), error);
            });
        };

        vm.getTaskElapsedTime = function (startTime) {

            if (!startTime) {
                return '';
            }

            var start = new Date(startTime.replace(' ', 'T'));
            var now = new Date();

            if (isNaN(start.getTime())) {
                return '';
            }

            var diffMs = now.getTime() - start.getTime();

            if (diffMs < 0) {
                return '';
            }

            var totalSeconds = Math.floor(diffMs / 1000);

            var hours = Math.floor(totalSeconds / 3600);
            var minutes = Math.floor((totalSeconds % 3600) / 60);
            var seconds = totalSeconds % 60;

            var result = [];

            if (hours > 0) {
                result.push(hours + 'h');
            }

            if (minutes > 0) {
                result.push(minutes + 'm');
            }

            if (seconds > 0 || result.length === 0) {
                result.push(seconds + 's');
            }

            return result.join(' ');
        };


        vm.comments = [];

        vm.getComments = function (cardId) {

            return KanbanService.GetComments(cardId).then(function (data) {

                vm.comments = data.comments;

                return vm.comments;

            }, function (error) {

                vm.showError(tr('Could not get the comments.'), error);

                vm.comments = [];

                return $q.reject(error);
            });
        };

        vm.newHistory = function (historyData) {

            return KanbanService.NewHistory(historyData).then(function (data) {
                if (!data.success) {
                    return $q.reject(data);
                }
                return data;

            }).catch(function (error) {

                vm.showError(tr('Could not save the history.'), error);

                return $q.reject(error);

            });
        };

        vm.history = [];

        // Recarga el historial si la tarjeta es la que está abierta (p. ej. tras
        // añadir o borrar tareas, que dejan su entrada en él).
        function refreshViewCardHistory(cardId) {

            if (!cardId || !vm.viewCard || String(vm.viewCard.id) !== String(cardId)) {
                return $q.when();
            }

            return vm.getHistory(cardId).catch(function () {
                // El error ya lo muestra vm.getHistory.
            });
        }

        vm.getHistory = function (cardId) {

            return KanbanService.GetHistory(cardId).then(function (data) {

                vm.history = data.history;

                return vm.history;

            }, function (error) {

                vm.showError(tr('Could not get the history.'), error);

                vm.history = [];

                return $q.reject(error);
            });
        };

        vm.getHistoryDuration = function (startTime, endTime) {
            if (!startTime || !endTime) {
                return '-';
            }

            var start = new Date(startTime);
            var end = new Date(endTime);

            if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                return '-';
            }

            var diffMs = end - start;

            if (diffMs < 0) {
                return '-';
            }

            var totalMinutes = Math.floor(diffMs / 60000);

            var days = Math.floor(totalMinutes / 1440);
            var hours = Math.floor((totalMinutes % 1440) / 60);
            var minutes = totalMinutes % 60;

            var result = [];

            if (days > 0) {
                result.push(days + ' ' + (days === 1 ? tr('day') : tr('days')));
            }

            if (hours > 0) {
                result.push(hours + 'h');
            }

            if (minutes > 0) {
                result.push(minutes + 'm');
            }

            return result.length ? result.join(' ') : '0m';
        };

        function sumLoggedHistoryMinutes(matches) {

            if (!vm.history || !vm.history.length) {
                return 0;
            }

            return vm.history.reduce(function (total, historyItem) {

                if (historyItem.title !== 'Horas registradas' || !historyItem.start_time || !historyItem.end_time || !matches(historyItem)) {
                    return total;
                }

                var start = new Date(historyItem.start_time.replace(' ', 'T'));
                var end = new Date(historyItem.end_time.replace(' ', 'T'));

                if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                    return total;
                }

                var diffMinutes = Math.floor((end.getTime() - start.getTime()) / 60000);

                return total + (diffMinutes > 0 ? diffMinutes : 0);

            }, 0);
        }

        function formatLoggedMinutes(totalMinutes) {

            if (totalMinutes <= 0) {
                return tr('No logged hours');
            }

            var hours = Math.floor(totalMinutes / 60);
            var minutes = totalMinutes % 60;

            var result = [];

            if (hours > 0) {
                result.push(hours + 'h');
            }

            if (minutes > 0) {
                result.push(minutes + 'm');
            }

            return result.join(' ');
        }

        vm.getTotalLoggedMinutes = function () {
            return sumLoggedHistoryMinutes(function () {
                return true;
            });
        };

        vm.getTotalLoggedTime = function () {
            return formatLoggedMinutes(vm.getTotalLoggedMinutes());
        };

        vm.getTaskLoggedMinutes = function (task) {
            return Number(task && task.loghours) || 0;
        };

        vm.getTaskLoggedTime = function (task) {
            return formatLoggedMinutes(vm.getTaskLoggedMinutes(task));
        };

        vm.tasks = [];

        function parseTaskDate(value) {

            if (!value) {
                return null;
            }

            var date = new Date(String(value).replace(' ', 'T'));

            return isNaN(date.getTime()) ? null : date;
        }

        // Límites de la intervención según las tareas: cuándo se empezó la
        // primera, cuándo se terminó la última y si están todas terminadas.
        function getInterventionBounds() {

            var firstStart = null;
            var lastEnd = null;
            var allFinished = true;

            (vm.tasks || []).forEach(function (task) {

                if (!task.finished) {
                    allFinished = false;
                }

                var start = parseTaskDate(task.start_time);
                var end = task.finished ? parseTaskDate(task.end_time) : null;

                if (start && (!firstStart || start < firstStart)) {
                    firstStart = start;
                }

                if (end && (!lastEnd || end > lastEnd)) {
                    lastEnd = end;
                }
            });

            return {
                firstStart: firstStart,
                lastEnd: lastEnd,
                // La intervención termina cuando están todas las tareas
                // terminadas; mientras tanto sigue "En curso".
                finished: !!firstStart && allFinished && !!lastEnd && lastEnd >= firstStart
            };
        }

        // true cuando se han terminado todas las tareas. "Tiempo de ejecución"
        // solo se muestra entonces.
        vm.isInterventionFinished = function () {
            return getInterventionBounds().finished;
        };

        // Hora inicio de intervención: cuando se empezó la primera tarea.
        vm.getInterventionStartTime = function () {

            var bounds = getInterventionBounds();

            return bounds.firstStart ? vm.formatCardDate(bounds.firstStart) : tr('No tasks started');
        };

        // Hora fin de intervención: cuando se terminó la última tarea.
        vm.getInterventionEndTime = function () {

            var bounds = getInterventionBounds();

            if (!bounds.firstStart) {
                return tr('No tasks started');
            }

            return bounds.finished ? vm.formatCardDate(bounds.lastEnd) : tr('In progress');
        };

        // Tiempo de ejecución de la tarjeta: desde que se empezó la primera
        // tarea hasta que se terminó la última. Mientras quede alguna tarea
        // sin terminar se muestra "En curso". Si sale menor que el tiempo
        // registrado, se muestra el tiempo registrado.
        vm.getExecutionTime = function () {

            var bounds = getInterventionBounds();
            var firstStart = bounds.firstStart;
            var lastEnd = bounds.lastEnd;

            if (!firstStart) {
                return tr('No tasks started');
            }

            if (!bounds.finished) {
                return tr('In progress');
            }

            var executionMinutes = Math.floor((lastEnd.getTime() - firstStart.getTime()) / 60000);
            var loggedMinutes = vm.getTotalLoggedMinutes();

            return formatDurationMinutes(Math.max(executionMinutes, loggedMinutes));
        };

        // Duración en minutos como "2 días 3h 15m" ("Menos de 1m" si es 0).
        function formatDurationMinutes(totalMinutes) {

            var days = Math.floor(totalMinutes / 1440);
            var hours = Math.floor((totalMinutes % 1440) / 60);
            var minutes = totalMinutes % 60;

            var result = [];

            if (days > 0) {
                result.push(days + ' ' + (days === 1 ? tr('day') : tr('days')));
            }

            if (hours > 0) {
                result.push(hours + 'h');
            }

            if (minutes > 0) {
                result.push(minutes + 'm');
            }

            return result.length ? result.join(' ') : tr('Less than 1m');
        }

        // "Tiempo fuera de servicio" = arranque de máquina - fecha del incidente.
        vm.getOutOfServiceTime = function () {

            if (!vm.viewCard) {
                return tr('No data');
            }

            var incidentTimestamp = vm.viewCard.general_info ? vm.viewCard.general_info.incident_timestamp : null;
            var machineStart = parseMachineStart(vm.viewCard.machine_start);

            if (!incidentTimestamp) {
                return tr('No incident date');
            }

            if (!machineStart) {
                return tr('No start-up recorded');
            }

            var totalMinutes = Math.floor((machineStart.getTime() - incidentTimestamp * 1000) / 60000);

            if (totalMinutes < 0) {
                return tr('The start-up is earlier than the incident');
            }

            return formatDurationMinutes(totalMinutes);
        };

        vm.hasOutOfServiceTime = function () {
            return !!(vm.viewCard && vm.viewCard.machine_start && vm.viewCard.general_info && vm.viewCard.general_info.incident_timestamp);
        };

        vm.completition = 0

        vm.getTasks = function (card) {
            return KanbanService.GetTasks(card.id).then(function (data) {
                vm.tasks = data.tasks || [];
                return vm.tasks;
            }).catch(function (error) {
                vm.showError(tr('Could not get the tasks.'), error);
                vm.tasks = [];
                return $q.reject(error);
            });
        };

        vm.calculateCompletionPercentage = function () {
            return vm.getTasks(vm.viewCard).then(function (tasks) {

                return updateCompletion(tasks);

            }).catch(function () {
                // El error ya lo muestra vm.getTasks.
                return 0;
            });
        };

        // Recalcula el % "Completed" del modal a partir de las tareas indicadas
        // (sin pedirlas otra vez) y actualiza la barra de progreso de la
        // tarjeta en el tablero.
        function updateCompletion(tasks) {

            tasks = tasks || [];

            var totalTasks = tasks.length;

            var completedTasks = tasks.filter(function (task) {
                return task.finished === 1 || task.finished === true;
            }).length;

            vm.completition = totalTasks ? Math.round((completedTasks / totalTasks) * 100) : 0;

            if (vm.viewCard && vm.viewCard.id) {
                vm.updateCardProgressInBoard(vm.viewCard.id, completedTasks, totalTasks);
            }

            return vm.completition;
        }

        // Mismo HTML que el bloque "Progress" de showcards.twig. Sin tareas no
        // se muestra la barra (igual que al cargar la página).
        vm.updateCardProgressInBoard = function (cardId, finished, total) {

            var cardElement = document.querySelector('.kanban-card[data-card-id="' + cardId + '"]');

            if (!cardElement) {
                return;
            }

            var progressEl = cardElement.querySelector('.kanban-card-progress');

            if (!total) {
                if (progressEl) {
                    progressEl.remove();
                }
                return;
            }

            var progress = Math.round((finished / total) * 100);

            var html = `<div class="kanban-card-progress mb-3">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <span class="d-flex align-items-center gap-1 small text-muted">
                        <span class="material-symbols-outlined" style="font-size:16px">checklist</span>
                        ${finished}/${total} ${tr('subtasks')}
                    </span>
                    <span class="small fw-semibold text-muted">${progress}%</span>
                </div>
                <div class="progress" style="height:6px" role="progressbar" aria-valuenow="${progress}" aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar ${progress === 100 ? 'bg-success' : 'bg-primary'}" style="width: ${progress}%"></div>
                </div>
            </div>`;

            if (progressEl) {
                progressEl.outerHTML = html;
                return;
            }

            var descriptionEl = cardElement.querySelector('.kanban-card-description');

            if (descriptionEl) {
                descriptionEl.insertAdjacentHTML('afterend', html);
            }
        };

        vm.newComment = {
            comment: ''
        };

        vm.publishDirectComment = function () {

            var comment = (vm.newComment.comment || '').trim();

            if (!comment) {
                return;
            }

            if (!vm.currentUser || !vm.currentUser.id) {
                vm.showError(tr('Could not get the current user.'));
                return $q.reject({ message: tr('Could not get the current user.') });
            }

            var commentData = {
                user: vm.currentUser.id,
                comment: comment,
                card: vm.viewCard.id
            };

            return KanbanService.NewComment(commentData).then(function (data) {

                if (!data.success) {
                    return $q.reject(data);
                }

                vm.newComment.comment = '';

                return vm.getComments(vm.viewCard.id);
            }).catch(function (error) {

                vm.showError(tr('Could not post the comment.'), error);
            });
        };

        vm.deleteAttachment = function (file) {

            if (!file || !file.id || !vm.viewCard || !vm.viewCard.id) {
                return;
            }

            vm.askConfirm({
                title: tr('Delete image'),
                message: tr('Are you sure you want to delete {name} from OT #{id}?', { name: '"' + (file.name || tr('this image')) + '"', id: vm.viewCard.id }),
                confirmLabel: tr('Delete image'),
                icon: 'delete',
                variant: 'danger',
                onConfirm: function () {
                    return vm.executeDeleteAttachment(file);
                }
            });
        };

        vm.executeDeleteAttachment = function (file) {

            var cardId = vm.viewCard.id;

            return KanbanService.DeleteCardFile(cardId, file.id).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.viewCard.attachments = data.attachments || [];

                vm.getHistory(cardId);

            }).catch(function (error) {

                vm.showError(tr('Could not delete the image.'), error);
            });
        };

        vm.uploadingAttachment = false;

        // Abre el explorador de archivos para elegir una imagen y, al
        // aceptarla, la sube y la añade al campo de imágenes de la tarjeta.
        vm.addFile = function (card) {

            if (!card || !card.id || vm.uploadingAttachment) {
                return;
            }

            var input = document.createElement('input');

            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/gif,image/webp';

            input.addEventListener('change', function () {

                var file = input.files && input.files[0];

                if (!file) {
                    return;
                }

                $scope.$applyAsync(function () {
                    vm.uploadAttachment(card.id, file);
                });
            });

            input.click();
        };

        vm.uploadAttachment = function (cardId, file) {

            if (!/^image\/(jpeg|png|gif|webp)$/.test(file.type)) {
                vm.showError(tr('The selected file is not a valid image (JPG, PNG, GIF or WEBP).'));
                return;
            }

            vm.uploadingAttachment = true;

            return KanbanService.UploadCardFile(cardId, file).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                // Por si se ha cambiado de tarjeta mientras se subía.
                if (vm.viewCard && String(vm.viewCard.id) === String(cardId)) {
                    vm.viewCard.attachments = data.attachments || [];
                    vm.getHistory(cardId);
                }

            }).catch(function (error) {

                vm.showError(tr('Could not upload the image.'), error);

            }).finally(function () {

                vm.uploadingAttachment = false;
            });
        };

        vm.isNewTaskModalOpen = false;

        vm.allNewTask = [];

        vm.newTaskCardId = null;

        vm.newTask = {
            title: '',
            description: ''
        };

        // Vista del modal: 'new' (tarea propia) o 'predefined' (listado de predefinidas).
        vm.newTaskView = 'new';

        // Página actual del listado de predefinidas. Las filas tienen alto
        // variable (la descripción ocupa hasta 3 líneas), así que en cada
        // página van las que caben una vez pintadas, y la siguiente empieza
        // por la primera que no cupo: se pagina por offset.
        vm.predefinedTasks = [];

        vm.predefinedTasksOffset = 0;

        vm.predefinedTasksTotal = 0;

        vm.predefinedTasksLoaded = false;

        vm.loadingPredefinedTasks = false;

        // Mientras se mide qué filas caben, se pintan ocultas.
        vm.measuringPredefinedTasks = false;

        vm.predefinedTaskSearch = '';

        // Tareas predefinidas marcadas ({id, title, description}), en el orden
        // en que se marcaron; se conservan al cambiar de página o de búsqueda.
        vm.selectedPredefinedTasks = [];

        // Offsets de las páginas anteriores, para volver atrás.
        var predefinedTasksPreviousOffsets = [];

        // La vista del listado mide el doble que la de nueva tarea.
        var PREDEFINED_VIEW_HEIGHT_FACTOR = 2;

        // Alto de la vista de nueva tarea si no se ha podido medir.
        var DEFAULT_NEW_TASK_VIEW_HEIGHT = 240;

        // Alto mínimo de una fila (solo título): con él se calcula cuántas
        // pedir como mucho para llenar el listado.
        var PREDEFINED_TASK_MIN_ITEM_HEIGHT = 36;

        vm.predefinedTaskViewHeight = DEFAULT_NEW_TASK_VIEW_HEIGHT * PREDEFINED_VIEW_HEIGHT_FACTOR;

        var predefinedTasksRequest = 0;

        // Filas que podrían caber en el listado si todas fueran de alto mínimo.
        function getPredefinedTasksMaxPerPage() {

            var list = document.getElementById('newTaskPredefinedList');
            var height = list ? list.clientHeight : 0;

            return Math.max(1, Math.min(50, Math.ceil(height / PREDEFINED_TASK_MIN_ITEM_HEIGHT) || 10));
        }

        // Filas pintadas que caben enteras en el listado (al menos una).
        function countFittingPredefinedTasks() {

            var list = document.getElementById('newTaskPredefinedList');

            if (!list) {
                return vm.predefinedTasks.length;
            }

            var rows = list.querySelectorAll('.kanban-predefined-task');
            var count = 0;

            for (var i = 0; i < rows.length; i++) {

                if (rows[i].offsetTop + rows[i].offsetHeight > list.clientHeight) {
                    break;
                }

                count++;
            }

            return Math.max(Math.min(1, rows.length), count);
        }


        vm.loadPredefinedTasks = function (offset) {

            // Solo vale la respuesta de la última petición (búsquedas rápidas).
            var request = ++predefinedTasksRequest;

            vm.loadingPredefinedTasks = true;

            return KanbanService.GetPredefinedTasks(vm.predefinedTaskSearch, offset || 0, getPredefinedTasksMaxPerPage()).then(function (data) {

                if (request !== predefinedTasksRequest) {
                    return;
                }

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.predefinedTasks = data.tasks || [];
                vm.predefinedTasksOffset = data.offset || 0;
                vm.predefinedTasksTotal = data.total || 0;
                vm.predefinedTasksLoaded = true;
                vm.measuringPredefinedTasks = true;

                // Tras pintarlas, se quitan las que no caben: pasan a la
                // página siguiente.
                return $timeout(function () {

                    if (request === predefinedTasksRequest) {
                        vm.predefinedTasks = vm.predefinedTasks.slice(0, countFittingPredefinedTasks());
                    }
                });

            }).catch(function (error) {

                if (request === predefinedTasksRequest) {
                    vm.showError(tr('Could not get the predefined tasks.'), error);
                }

            }).finally(function () {

                if (request === predefinedTasksRequest) {
                    vm.loadingPredefinedTasks = false;
                    vm.measuringPredefinedTasks = false;
                }
            });
        };

        vm.searchPredefinedTasks = function () {

            predefinedTasksPreviousOffsets = [];

            return vm.loadPredefinedTasks(0);
        };

        vm.getPredefinedTasksPage = function () {
            return predefinedTasksPreviousOffsets.length + 1;
        };

        vm.hasPreviousPredefinedTasksPage = function () {
            return predefinedTasksPreviousOffsets.length > 0;
        };

        vm.hasNextPredefinedTasksPage = function () {
            return vm.predefinedTasksOffset + vm.predefinedTasks.length < vm.predefinedTasksTotal;
        };

        vm.previousPredefinedTasksPage = function () {

            if (!vm.hasPreviousPredefinedTasksPage() || vm.loadingPredefinedTasks) {
                return;
            }

            return vm.loadPredefinedTasks(predefinedTasksPreviousOffsets.pop());
        };

        vm.nextPredefinedTasksPage = function () {

            if (!vm.hasNextPredefinedTasksPage() || vm.loadingPredefinedTasks) {
                return;
            }

            predefinedTasksPreviousOffsets.push(vm.predefinedTasksOffset);

            return vm.loadPredefinedTasks(vm.predefinedTasksOffset + vm.predefinedTasks.length);
        };

        vm.setNewTaskView = function (view) {

            // Se mide la vista de nueva tarea antes de ocultarla (sin el
            // mensaje de error, que la haría más alta de lo normal).
            if (view === 'predefined' && vm.newTaskView === 'new' && !vm.fieldErrors['newTask.title']) {

                var newView = document.getElementById('newTaskViewNew');

                if (newView && newView.offsetHeight) {
                    vm.predefinedTaskViewHeight = newView.offsetHeight * PREDEFINED_VIEW_HEIGHT_FACTOR;
                }
            }

            vm.newTaskView = view;

            vm.clearFieldError('newTask.title');

            if (view === 'predefined' && !vm.predefinedTasksLoaded && !vm.loadingPredefinedTasks) {

                // Tras pintar el listado, para saber su alto.
                $timeout(function () {
                    vm.searchPredefinedTasks();
                });
            }
        };

        function normalizeTaskTitle(title) {
            return String(title || '').replace(/\s+/g, ' ').trim().toUpperCase();
        }

        // Títulos de las tareas que ya tiene la tarjeta (o que se crearán con ella).
        function getExistingTaskTitles() {

            var titles = {};

            (vm.newTaskCardId ? (vm.tasks || []) : vm.allNewTask).forEach(function (task) {
                titles[normalizeTaskTitle(task.title)] = true;
            });

            return titles;
        }

        vm.isPredefinedTaskAdded = function (predefined) {
            return !!getExistingTaskTitles()[normalizeTaskTitle(predefined.title)];
        };

        function findSelectedPredefinedTaskIndex(predefined) {

            for (var i = 0; i < vm.selectedPredefinedTasks.length; i++) {
                if (String(vm.selectedPredefinedTasks[i].id) === String(predefined.id)) {
                    return i;
                }
            }

            return -1;
        }

        vm.isPredefinedTaskSelected = function (predefined) {
            return findSelectedPredefinedTaskIndex(predefined) !== -1;
        };

        vm.getSelectedPredefinedTasks = function () {

            return vm.selectedPredefinedTasks.filter(function (predefined) {
                return !vm.isPredefinedTaskAdded(predefined);
            });
        };

        vm.togglePredefinedTask = function (predefined) {

            if (vm.isPredefinedTaskAdded(predefined)) {
                return;
            }

            var index = findSelectedPredefinedTaskIndex(predefined);

            if (index !== -1) {
                vm.selectedPredefinedTasks.splice(index, 1);
            } else {
                vm.selectedPredefinedTasks.push({
                    id: predefined.id,
                    title: predefined.title,
                    description: predefined.description || ''
                });
            }
        };


        vm.openNewTaskModal = function (cardId) {

            vm.newTask = {
                title: '',
                description: ''
            };

            vm.newTaskView = 'new';

            vm.predefinedTasks = [];

            vm.predefinedTasksOffset = 0;

            vm.predefinedTasksTotal = 0;

            vm.predefinedTasksLoaded = false;

            predefinedTasksPreviousOffsets = [];

            vm.predefinedTaskSearch = '';

            vm.selectedPredefinedTasks = [];

            vm.newTaskCardId = cardId || null;

            vm.clearFieldError('newTask.title');

            vm.isNewTaskModalOpen = true;
        };


        vm.closeNewTaskModal = function () {

            vm.isNewTaskModalOpen = false;

            vm.clearFieldError('newTask.title');

            vm.newTaskCardId = null;

            vm.newTask = {
                title: '',
                description: ''
            };

            vm.newTaskView = 'new';

            vm.predefinedTaskSearch = '';

            vm.selectedPredefinedTasks = [];
        };


        vm.addTask = function () {

            var tasks;

            if (vm.newTaskView === 'predefined') {

                tasks = vm.getSelectedPredefinedTasks().map(function (predefined) {
                    return {
                        title: predefined.title,
                        description: predefined.description
                    };
                });

                if (!tasks.length) {
                    return;
                }

            } else {

                var task = {
                    title: (vm.newTask.title || '').trim(),
                    description: (vm.newTask.description || '').trim()
                };

                if (!task.title) {
                    vm.fieldErrors['newTask.title'] = tr('You must enter a title for the task.');
                    return;
                }

                tasks = [task];
            }

            var isGroup = vm.newTaskView === 'predefined';

            if (vm.newTaskCardId) {

                var cardId = vm.newTaskCardId;

                return createTasks(cardId, tasks, isGroup).then(function () {

                    vm.closeNewTaskModal();

                }).catch(function (error) {

                    vm.showError(tr('Could not create the task.'), error);

                }).finally(function () {

                    // Aunque alguna falle, las demás pueden haberse creado.
                    refreshViewCardHistory(cardId);

                    return vm.calculateCompletionPercentage();
                });
            }

            // Tarjeta aún sin crear: las predefinidas se marcan con el mismo
            // grupo para crearlas juntas (una entrada en el historial).
            if (isGroup) {

                var group = ++newTaskGroupCounter;

                tasks.forEach(function (newTask) {
                    newTask.group = group;
                });
            }

            Array.prototype.push.apply(vm.allNewTask, tasks);

            vm.closeNewTaskModal();
        };

        var newTaskGroupCounter = 0;

        // Crea tareas en la tarjeta: un grupo (predefinidas) de una vez, con una
        // sola entrada en el historial; si no, una a una y en orden (la primera
        // tarea de la tarjeta bloquea a las demás).
        function createTasks(cardId, tasks, isGroup) {

            if (isGroup) {

                return KanbanService.NewTasks(cardId, tasks.map(function (task) {
                    return {
                        title: task.title,
                        description: task.description
                    };
                })).then(function (data) {

                    if (!data || !data.success) {
                        return $q.reject(data);
                    }

                    return data;
                });
            }

            return tasks.reduce(function (previous, task) {

                return previous.then(function () {

                    return KanbanService.NewTask({
                        title: task.title,
                        description: task.description,
                        card: cardId
                    });

                }).then(function (data) {

                    if (!data || !data.success) {
                        return $q.reject(data);
                    }

                    return data;
                });

            }, $q.when());
        }

        vm.createAllNewTask = function (cardId) {

            if (!vm.allNewTask.length) {
                return $q.when();
            }

            // Tareas pendientes en bloques, en orden: cada grupo de
            // predefinidas junto, y las propias sueltas.
            var batches = [];

            vm.allNewTask.forEach(function (task) {

                var last = batches[batches.length - 1];

                if (task.group && last && last.group === task.group) {
                    last.tasks.push(task);
                } else {
                    batches.push({ group: task.group || null, tasks: [task] });
                }
            });

            return batches.reduce(function (previous, batch) {

                return previous.then(function () {
                    return createTasks(cardId, batch.tasks, !!batch.group);
                });

            }, $q.when());
        };

        vm.startEditingViewCard = function () {
            if (!vm.viewCard) {
                return;
            }

            vm.editCard = angular.copy(vm.viewCard);

            vm.editCard.priority =
                vm.editCard.priority === 1 ||
                vm.editCard.priority === true ||
                vm.editCard.priority === '1';

            vm.editCard.is_recurring =
                vm.editCard.is_recurring === 1 ||
                vm.editCard.is_recurring === true ||
                vm.editCard.is_recurring === '1';

            var timeEstimate = vm.parseTimeEstimate(vm.editCard.time_estimate);

            vm.editCard.time_estimate_hours = timeEstimate.hours || null;
            vm.editCard.time_estimate_minutes = timeEstimate.minutes || null;
            vm.editCard.time_estimate_seconds = timeEstimate.seconds || null;

            vm.selectedUsers = [];
            vm.userSearchTerm = '';

            if (vm.viewCard.assigned_to) {
                vm.viewCard.assigned_to.forEach(function (user) {
                    vm.selectedUsers.push(user.id);
                });
            }

            if (vm.editCard.planification_date) {

                if (angular.isString(vm.editCard.planification_date)) {
                    vm.editCard.planification_date = new Date(vm.editCard.planification_date.replace(' ', 'T'));
                } else {
                    vm.editCard.planification_date = new Date(vm.editCard.planification_date);
                }
            }

            // Las relaciones llegan cargadas (objetos); los desplegables
            // trabajan con ids.
            vm.editCard.machine = toNodeId(vm.editCard.machine);
            vm.editCard.line = toNodeId(vm.editCard.line);
            vm.editCard.maintenance_application = toNodeId(vm.editCard.maintenance_application);
            vm.editCard.corrective_ot = toNodeId(vm.editCard.corrective_ot);

            vm.resetFieldErrors();

            vm.isEditingViewCard = true;

            vm.getUsers();

            vm.loadGeneralInfoOptions();
        };

        vm.isUserSelected = function (user) {
            return vm.selectedUsers.indexOf(user.id) !== -1;
        };

        vm.getSelectedUsersNames = function () {

            if (!vm.allUsers || !vm.selectedUsers || !vm.selectedUsers.length) {
                return '';
            }

            return vm.allUsers
                .filter(function (user) {
                    return vm.selectedUsers.indexOf(user.id) !== -1;
                })
                .map(function (user) {
                    return user.name;
                })
                .join(', ');
        };

        vm.cancelEditingViewCard = function () {
            vm.isEditingViewCard = false;

            vm.resetFieldErrors();
        };

        vm.saveViewCard = function () {

            return vm.updateCard().then(function () {

                vm.isEditingViewCard = false;

            }).catch(function (error) {

                // Los errores de validación ya se marcan en los campos.
                if (error && error.isValidation) {
                    return;
                }

                vm.showError(tr('Could not update the OT.'), error);

            });
        };

        vm.isLogHoursModalOpen = false;

        vm.logHours = {
            hours: null,
            minutes: null,
            taskId: null
        };

        vm.openLogHoursModal = function (taskId) {

            vm.logHours = {
                hours: null,
                minutes: null,
                taskId: taskId || null
            };

            vm.clearFieldError('logHours.time');

            vm.isLogHoursModalOpen = true;
        };

        vm.closeLogHoursModal = function () {
            vm.isLogHoursModalOpen = false;

            vm.clearFieldError('logHours.time');
        };

        vm.saveLogHours = function () {

            var hours = Number(vm.logHours.hours) || 0;
            var minutes = Number(vm.logHours.minutes) || 0;

            if (hours <= 0 && minutes <= 0) {
                vm.fieldErrors['logHours.time'] = tr('You must enter a valid time.');
                return;
            }

            if (!vm.currentUser || !vm.currentUser.id) {
                vm.showError(tr('Could not get the current user.'));
                return;
            }

            var payload = {
                cardID: vm.viewCard.id,
                taskID: vm.logHours.taskId || null,
                user: vm.currentUser.id,
                hours: hours,
                minutes: minutes
            };

            return KanbanService.LogCardHours(payload).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.closeLogHoursModal();

                if (data.task) {
                    var task = (vm.tasks || []).find(function (t) {
                        return String(t.id) === String(data.task.id);
                    });

                    if (task) {
                        task.loghours = data.task.loghours;
                    }
                }

                return vm.getHistory(vm.viewCard.id).then(function () {
                    vm.updateCardLoggedTimeInBoard(vm.viewCard.id, vm.getTotalLoggedTime());
                });

            }).catch(function (error) {

                vm.showError(tr('Could not log the hours.'), error);

            });
        };

        vm.updateCardLoggedTimeInBoard = function (cardId, loggedTime) {

            var cardElement = document.querySelector('.kanban-card[data-card-id="' + cardId + '"]');

            if (!cardElement) {
                return;
            }

            var loggedTimeEl = cardElement.querySelector('.kanban-card-logged-time');

            if (loggedTimeEl) {
                loggedTimeEl.textContent = loggedTime;
            }
        };

        vm.cloneCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            vm.askConfirm({
                title: tr('Clone OT'),
                message: tr('Do you want to clone OT #{id} {title}?', { id: vm.viewCard.id, title: '"' + (vm.viewCard.title || '') + '"' }),
                confirmLabel: tr('Clone'),
                icon: 'content_copy',
                variant: 'primary',
                onConfirm: vm.executeCloneCard
            });
        };

        vm.executeCloneCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            return KanbanService.CloneCard(vm.viewCard.id).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.addCardToColumn(data.card);

                vm.updateCardLoggedTimeInBoard(data.card.id, vm.getTotalLoggedTime());

                vm.closeViewCardModal();

            }).catch(function (error) {

                vm.showError(tr('Could not clone the OT.'), error);
            });
        };

        vm.deleteCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            // Con tarjetas derivadas no se puede borrar (el servidor también lo
            // comprueba): se avisa sin pedir confirmación.
            if ((vm.viewCard.related_cards || []).length) {
                vm.showError(tr('This OT has derived OTs. You must delete the derived OTs first.'));
                return;
            }

            vm.askConfirm({
                title: tr('Delete OT'),
                message: tr('Are you sure you want to delete OT #{id} {title}? It will no longer be shown on the boards.', { id: vm.viewCard.id, title: '"' + (vm.viewCard.title || '') + '"' }),
                confirmLabel: tr('Delete OT'),
                icon: 'delete',
                variant: 'danger',
                onConfirm: vm.executeDeleteCard
            });
        };

        vm.executeDeleteCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            var cardId = vm.viewCard.id;

            return KanbanService.DeleteCard(cardId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                removeCardFromBoard(cardId);

                vm.closeViewCardModal();

            }).catch(function (error) {

                vm.showError(tr('Could not delete the OT.'), error);

            });
        };

        // Quita la tarjeta del tablero (eliminada o archivada) y actualiza
        // el mensaje de columna vacía y los contadores.
        function removeCardFromBoard(cardId) {

            var cardElement = document.querySelector('.kanban-card[data-card-id="' + cardId + '"]');

            if (!cardElement) {
                return;
            }

            var column = cardElement.closest('.kanban-column');

            cardElement.remove();

            if (column) {
                vm.updateEmptyMessage(column);
                vm.updateStateCounters();
            }
        }

        // Archivar: la tarjeta se marca como archivada (is_archived) y deja de
        // mostrarse en el tablero.
        vm.archiveCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            vm.askConfirm({
                title: tr('Archive OT'),
                message: tr('Are you sure you want to archive OT #{id} {title}? It will no longer be shown on the boards.', { id: vm.viewCard.id, title: '"' + (vm.viewCard.title || '') + '"' }),
                confirmLabel: tr('Archive OT'),
                icon: 'archive',
                variant: 'primary',
                onConfirm: vm.executeArchiveCard
            });
        };

        vm.executeArchiveCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            var cardId = vm.viewCard.id;

            return KanbanService.ArchiveCard(cardId).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                removeCardFromBoard(cardId);

                vm.closeViewCardModal();

            }).catch(function (error) {

                vm.showError(tr('Could not archive the OT.'), error);

            });
        };

        // --- Tarjetas archivadas del tablero (modal) ----------------------

        vm.archivedCardsModal = { open: false, loading: false, cards: [], unarchivingId: null };

        vm.openArchivedCardsModal = function () {

            vm.archivedCardsModal = { open: true, loading: true, cards: [], unarchivingId: null };

            return KanbanService.GetArchivedCards(vm.selectedBoard ? vm.selectedBoard.id : null).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.archivedCardsModal.cards = data.cards || [];

            }).catch(function (error) {

                vm.showError(tr('Could not get the archived OTs.'), error);

            }).finally(function () {

                vm.archivedCardsModal.loading = false;
            });
        };

        vm.closeArchivedCardsModal = function () {
            vm.archivedCardsModal.open = false;
        };

        vm.askUnarchiveCard = function (card) {

            if (!card || vm.archivedCardsModal.unarchivingId) {
                return;
            }

            vm.askConfirm({
                title: tr('Unarchive OT'),
                message: tr('Do you want to unarchive OT #{id} {title}? It will be shown on the board again.', { id: card.id, title: '"' + (card.title || '') + '"' }),
                confirmLabel: tr('Unarchive OT'),
                icon: 'unarchive',
                variant: 'primary',
                onConfirm: function () {
                    return executeUnarchiveCard(card);
                }
            });
        };

        function executeUnarchiveCard(card) {

            vm.archivedCardsModal.unarchivingId = card.id;

            return KanbanService.UnarchiveCard(card.id).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.archivedCardsModal.cards = vm.archivedCardsModal.cards.filter(function (archived) {
                    return String(archived.id) !== String(card.id);
                });

                // Vuelve a su columna si está en este tablero (si no, se verá
                // al abrir el tablero de su estado).
                var restored = data.card;
                var stateId = restored && angular.isObject(restored.state) ? restored.state.id : (restored ? restored.state : null);

                if (restored && stateId && document.querySelector('.kanban-column[data-state-id="' + stateId + '"]')) {
                    vm.addCardToColumn(restored);

                    // Barra de progreso de sus tareas, igual que al crear una tarjeta.
                    KanbanService.GetTasks(restored.id).then(function (taskData) {

                        var tasks = (taskData && taskData.tasks) || [];

                        var finished = tasks.filter(function (task) {
                            return task.finished === 1 || task.finished === true;
                        }).length;

                        vm.updateCardProgressInBoard(restored.id, finished, tasks.length);
                    }, function () {
                        // Solo afecta a la vista previa; al recargar se ve bien.
                    });
                }

            }).catch(function (error) {

                vm.showError(tr('Could not unarchive the OT.'), error);

            }).finally(function () {

                vm.archivedCardsModal.unarchivingId = null;
            });
        }

        // --- Importación de OTs desde un CSV (modal) ----------------------

        vm.importOtsModal = { open: false, file: null, dryRun: false, importing: false, result: null };

        vm.openImportOtsModal = function () {
            vm.importOtsModal = { open: true, file: null, dryRun: false, importing: false, result: null };
        };

        // Si se ha creado alguna OT se recarga el tablero para verlas (y los estados nuevos).
        vm.closeImportOtsModal = function () {

            if (vm.importOtsModal.importing) {
                return;
            }

            var result = vm.importOtsModal.result;

            vm.importOtsModal.open = false;

            if (result && result.success && !result.dryRun && result.created > 0) {
                window.location.reload();
            }
        };

        vm.chooseImportOtsFile = function () {

            var input = document.createElement('input');

            input.type = 'file';
            input.accept = '.csv,text/csv';

            input.addEventListener('change', function () {

                var file = input.files && input.files[0];

                if (!file) {
                    return;
                }

                $scope.$applyAsync(function () {
                    vm.importOtsModal.file = file;
                    vm.importOtsModal.result = null;
                });
            });

            input.click();
        };

        vm.importOts = function () {

            var modal = vm.importOtsModal;

            if (!modal.file || modal.importing) {
                return;
            }

            modal.importing = true;
            modal.result = null;

            var dryRun = modal.dryRun;

            return KanbanService.ImportOts(modal.file, vm.selectedBoard ? vm.selectedBoard.id : null, dryRun).then(function (data) {

                // Los errores de la importación (p. ej. sin columna OT) también traen su registro
                var result = data && data.data && data.data.log ? data.data : data;

                if (!result || !result.log) {
                    return $q.reject(data);
                }

                result.dryRun = dryRun;
                modal.result = result;

            }).catch(function (error) {

                vm.showError(tr('Could not import the OTs.'), error);

            }).finally(function () {

                modal.importing = false;
            });
        };

        vm.isCardCancelled = function (card) {
            return !!card && !!card.is_cancelled && Number(card.is_cancelled) !== 0;
        };

        vm.isCancelCardModalOpen = false;

        vm.cancelCardAction = true;

        vm.toggleCancelCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                return;
            }

            vm.cancelCardAction = !vm.isCardCancelled(vm.viewCard);

            // Con tarjetas derivadas no se puede cancelar (el servidor también
            // lo comprueba); reactivarla sí.
            if (vm.cancelCardAction && (vm.viewCard.related_cards || []).length) {
                vm.showError(tr('This OT has derived OTs. You must delete the derived OTs first.'));
                return;
            }

            vm.isCancelCardModalOpen = true;
        };

        vm.closeCancelCardModal = function () {
            vm.isCancelCardModalOpen = false;
        };

        vm.confirmCancelCard = function () {

            if (!vm.viewCard || !vm.viewCard.id) {
                vm.closeCancelCardModal();
                return;
            }

            var cardId = vm.viewCard.id;
            var cancel = vm.cancelCardAction;

            return KanbanService.CancelCard(cardId, cancel).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.viewCard.is_cancelled = cancel ? 1 : 0;

                // El backend quita prioridad y recurrencia al cancelar.
                if (cancel) {
                    vm.viewCard.priority = 0;
                    vm.viewCard.is_recurring = 0;
                    vm.viewCard.recurring_days = 0;
                }

                vm.updateCardCancelledInBoard(cardId, cancel);

                vm.getHistory(cardId);

            }).catch(function (error) {

                vm.showError(cancel ? tr('Could not cancel the OT.') : tr('Could not reactivate the OT.'), error);

            }).finally(function () {

                vm.closeCancelCardModal();
            });
        };

        vm.updateCardCancelledInBoard = function (cardId, cancelled) {

            var cardElement = document.querySelector('.kanban-card[data-card-id="' + cardId + '"]');

            if (!cardElement) {
                return;
            }

            cardElement.classList.toggle('kanban-card-cancelled', cancelled);

            if (cancelled) {
                cardElement.setAttribute('data-priority', '0');
                cardElement.querySelectorAll('.kanban-card-priority, .kanban-card-recurrent').forEach(function (flag) {
                    flag.remove();
                });
            }

            var badge = cardElement.querySelector('.kanban-card-cancelled-badge');

            if (cancelled && !badge) {

                var titleRow = cardElement.querySelector('.kanban-card-title');

                if (titleRow && titleRow.parentElement) {
                    titleRow.parentElement.insertAdjacentHTML('beforeend', '<span class="kanban-card-cancelled-badge badge bg-danger ms-auto flex-shrink-0">' + tr('Cancelled') + '</span>');
                }

            } else if (!cancelled && badge) {
                badge.remove();
            }
        };
    }
})();
